import { Box, FormControl, Modal, CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import {
  isStaleCartError,
  clearStaleCartStorage,
  showStaleCartDialog,
} from "../../../../../utils/staleCartHandler";
import PalletScooter from "assets/images/illustrations/pallet-scooter.png";
import {
  XMarkIcon,
  MapPinIcon,
  ShoppingBagIcon,
  BuildingStorefrontIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import React, { useContext, useEffect, useState, useRef } from "react";
import { debounce } from "lodash";
import { countryOptions } from "../../../posnavbar/components/addCustomer/data/countries-details";
import {
  INDIA_STATES,
  getCitiesForState,
  normaliseState,
} from "../components/DeliveryAddressModal/india-states-cities";
import NewCountryCodeInput from "./NewCountryCodeInput";
import CustomStateSelect from "./CustomStateSelect";
import CountryCodeInput from "../../../posnavbar/components/addCustomer/components/countryCodeInput";
import { BootstrapInput } from "../../../posnavbar/components/addCustomer/components/bootStrapInput";
import "./CartCustomerDetails.css";
import { colorConstant } from "../../../../../styles/colorConstant/colorConstant";
import { customEventTrigger } from "../../../../../analytics";
import {
  addCustomer,
  // AddedCustomerData,
  createB2CcustomerApi,
  // customerSearch,
  customerSearchV2Api,
  getLoyaltyInfo,
  manualTableReservation,
  restaurantCreateCart,
  SkipUserFun,
  getAddress,
  createAddress,
  restaurantCartUpdate,
  filterCutoff,
  updateAddress,
  createSalesOrderCart,
} from "../../../../../config/Services";
import GstPartnerModal from "./GstPartnerModal";
import useCustomerInsights, {
  formatInsightCurrency,
  formatInsightCount,
  formatInsightDate,
  InsightSpinner,
} from "../../../../../hooks/useCustomerInsights";
import { convertToLocalTime } from "../Middleware/commonUtils";
import moment from "moment";
import { useDispatch } from "react-redux";
import { changePrevAddedTime, eventTrackerTime } from "../redux/Actions/eventTracker";
import { useSnackbar } from "../../hooks/SnackbarProvider";
import { UserContext } from "../../../../../App";
import useGetDevice from "../../hooks/useGetDevice";
import AachiLogo from "../../../../../assets/images/logos/aachi-logo.png";
import WhatsAppLogo from "../../../../../assets/images/logos/whatsapp-logo.png";
import { useSelector } from "react-redux";
import { getMobilePos } from "../redux/Reducers/paginationReducer";
import {
  removeFromLocalStorage,
  setInLocalStorage,
} from "../../../../../utils/localStorageHelpers";
import { useNavigate } from "react-router-dom";

const getRelativeTime = (dateStr) => {
  if (!dateStr) return null;
  const diff = Date.now() - new Date(dateStr).getTime();
  const days = Math.max(0, Math.floor(diff / 86400000));
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
  return `${Math.floor(months / 12)} year${Math.floor(months / 12) > 1 ? "s" : ""} ago`;
};

const AddressPinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.46 2 2 0 0 1 3.57 1.28h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.64a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const RESTAURANT_TIPS = [
  {
    icon: "🎯",
    text: "Regulars spend 67% more than first-timers. Capture every customer — it pays off fast.",
  },
  {
    icon: "📱",
    text: "Customers who get order confirmations reorder 2× more. WhatsApp updates close that loop.",
  },
  {
    icon: "⚡",
    text: "Instant dispatch cuts average wait time by 4 minutes — a game-changer at peak hours.",
  },
  {
    icon: "📊",
    text: "Restaurants with digital order tracking cut errors by 35% and keep kitchens calm.",
  },
  {
    icon: "🚴",
    text: "Delivery zones under 3 km keep food hot, ratings high, and drivers efficient.",
  },
  {
    icon: "🏆",
    text: "The top 10% of restaurant POS users reconcile every shift. Small habit, big clarity.",
  },
];

/* ─────────────────────────────────────────────────────────────
   Pallet delivery-boy transit animation — mirrors GroceryEmptyCart
   1 s drive-in → 2 s stop → 1 s drive-out → 1.5 s pause → repeat
   ───────────────────────────────────────────────────────────── */
const CcdDeliveryMascot = () => {
  const [phase, setPhase] = useState("pre");
  const [bouncing, setBouncing] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [tipIdx, setTipIdx] = useState(0);
  const [tipVisible, setTipVisible] = useState(false);
  const [cycleKey, setCycleKey] = useState(0);

  useEffect(() => {
    setPhase("pre");
    setBouncing(false);
    const timers = [
      setTimeout(() => setPhase("driving-in"), 60),
      setTimeout(() => {
        setPhase("stopped");
        setBouncing(true);
        setTimeout(() => setBouncing(false), 520);
      }, 1060),
      setTimeout(() => {
        setShowMessage(true);
        setTipVisible(true);
      }, 1760),
      setTimeout(() => setPhase("driving-out"), 3060),
      setTimeout(() => {
        setPhase("done");
        setTimeout(() => setCycleKey((k) => k + 1), 1500);
      }, 4060),
    ];
    return () => timers.forEach(clearTimeout);
  }, [cycleKey]);

  useEffect(() => {
    if (!showMessage) return;
    const id = setInterval(() => {
      setTipVisible(false);
      setTimeout(() => {
        setTipIdx((i) => (i + 1) % RESTAURANT_TIPS.length);
        setTipVisible(true);
      }, 380);
    }, 4500);
    return () => clearInterval(id);
  }, [showMessage]);

  const isMoving = phase === "driving-in" || phase === "driving-out";
  const tip = RESTAURANT_TIPS[tipIdx];

  const scooterLeft =
    phase === "pre"
      ? "-220px"
      : phase === "driving-out" || phase === "done"
      ? "calc(100% + 20px)"
      : "calc(50% - 100px)";
  const scooterTransition =
    phase === "driving-in"
      ? "left 1s cubic-bezier(0.22, 1, 0.36, 1)"
      : phase === "driving-out"
      ? "left 1s cubic-bezier(0.64, 0, 0.78, 0)"
      : "none";

  return (
    <div className="ccd-mascot-root">
      <div className="ccd-mascot-lane">
        {isMoving && (
          <div className="ccd-mascot-speed-wrap">
            <span className="ccd-ms ccd-ms--1" />
            <span className="ccd-ms ccd-ms--2" />
            <span className="ccd-ms ccd-ms--3" />
            <span className="ccd-ms ccd-ms--4" />
            <span className="ccd-ms ccd-ms--5" />
          </div>
        )}
        <div className="ccd-mascot-ground" />
        <div
          className="ccd-mascot-scooter-outer"
          style={{ left: scooterLeft, transition: scooterTransition }}
        >
          <img
            src={PalletScooter}
            alt="Pallet delivery scooter"
            className={`ccd-mascot-scooter-img${bouncing ? " ccd-mascot-scooter-img--bounce" : ""}`}
            draggable={false}
          />
        </div>
      </div>
      <div className="ccd-mascot-inner">
        <div className={`ccd-mascot-text${showMessage ? " ccd-mascot-text--in" : ""}`}>
          <h3 className="ccd-mascot-title">Add a customer to begin</h3>
          <p className="ccd-mascot-sub">
            Enter a mobile number to unlock delivery, takeaway &amp; loyalty
          </p>
        </div>
        {showMessage && (
          <div className="ccd-mascot-tip-row" style={{ opacity: tipVisible ? 1 : 0 }}>
            <span className="ccd-mascot-tip-icon" role="img" aria-hidden="true">
              {tip.icon}
            </span>
            <p className="ccd-mascot-tip-text">{tip.text}</p>
          </div>
        )}
      </div>
    </div>
  );
};

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: "6px" }}
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const CartCustomerDetails = ({
  open,
  cartItems,
  setCartItems,
  setOpenCartCustomerDetail,
  setName,
  setCustomerLoader,
  slotDetails,
  setSlotDetails,
  deliveryCharge,
  setDeliveryCharge,
  packingCharge,
  setPackingCharge,
  deliveryChargesLoader,
  setDeliveryChargesLoader,
  packingChargesLoader,
  setPackingChargesLoader,
}) => {
  const [selectedCountry, setSelectedCountry] = useState(
    () =>
      countryOptions.find((c) => c.value === "+91") || {
        label: "India (+91)",
        value: "+91",
        flag: "🇮🇳",
        iso: "IN",
      }
  );
  const [whatsAppCheck, setWhatsAppCheck] = useState(false);
  const [skipModelLoader, setSkipModelLoader] = useState(false);
  const [adjustCheck, setAdjustCheck] = useState(false);
  const [customerMobile, setCustomerMobile] = useState(
    JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber || ""
  );
  const [splitActive, setSplitActive] = useState(false);
  const [partialStatus, setPartailStatus] = useState(false);
  const [addModelLoader, setAddModelLoader] = useState(false);
  const [customerSuccess, setCustomerSuccess] = useState(false);
  const [customerSearchLoader, setCustomerSearchLoader] = useState(false);
  const [customerFound, setCustomerFound] = useState(false);
  const [customerUidx, setCustomerUidx] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [foundCustomer, setFoundCustomer] = useState(null);
  const { insights, insightsLoading } = useCustomerInsights({
    uidx: customerUidx,
    id: customerId,
  });
  const tilesLoading = customerSearchLoader || insightsLoading;

  // Delivery address states
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [addressFetchLoader, setAddressFetchLoader] = useState(false);
  const [deliveryAddressForm, setDeliveryAddressForm] = useState({
    addressType: "HOME",
    otherName: "",
    house: "",
    apartment: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    phone: "",
    latitude: null,
    longitude: null,
  });
  // Ref for house input (used for programmatic value updates in edit mode)
  const ccdHouseInputRef = useRef(null);
  // Custom places autocomplete state
  const [ccdSuggestions, setCcdSuggestions] = useState([]);
  const [ccdDropdownOpen, setCcdDropdownOpen] = useState(false);
  const ccdDebounceRef = useRef(null);
  const [addressFormErrors, setAddressFormErrors] = useState({});
  const [editingAddressId, setEditingAddressId] = useState(null);

  const [pickupMode, setPickupMode] = useState("instant");
  const [date, setDate] = useState(new Date());
  const [slotList, setSlotList] = useState([]);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const dispatch = useDispatch();
  const showSnackbar = useSnackbar();
  const isMobile = useGetDevice();
  const isMobilePos = useSelector(getMobilePos);
  const navigate = useNavigate();

  const { setCartId, setCartTotalQty } = useContext(UserContext);
  const { customerName, setCustomerName } = useContext(UserContext);
  const branchSubType = localStorage.getItem("branchSubType");
  const { customerMobileNumber, setCustomerMobileNumber } = useContext(UserContext);
  const { sgst, setSgst, setSaleMode, saleMode, setCess } = useContext(UserContext);
  const { cgst, setCgst } = useContext(UserContext);
  const { subTotal, setSubTotal, setTotalValue } = useContext(UserContext);
  const { total, setTotal, totalTaxes, setTotalTaxes } = useContext(UserContext);
  const { selectedTable, setSelectedTable } = useContext(UserContext);
  const { customerActionButton, setCustomerActionButton } = useContext(UserContext);
  // FINE_DINE can always close; QSR must add/skip properly; others hide close on DELIVERY/TAKE_AWAY
  const hideCloseBtn =
    branchSubType === "QSR" ||
    (branchSubType !== "FINE_DINE" && (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY"));

  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));
  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");
  const sessionId = localStorage.getItem("sessionId");
  const licenseId = localStorage.getItem("licenseId");
  const cartId = localStorage.getItem("CartId");
  const licenseName = localStorage.getItem("licenseName");
  const retailType = localStorage.getItem("retailType");

  const [deliveryCharges, setDeliveryChargesLocal] = useState("");
  const [packingCharges, setPackingChargesLocal] = useState("");

  // Sync charges with prop values when modal/drawer opens or when prop changes
  useEffect(() => {
    if (open) {
      setDeliveryChargesLocal(deliveryCharge ? String(deliveryCharge) : "");
      setPackingChargesLocal(packingCharge ? String(packingCharge) : "");
    }
  }, [open, deliveryCharge, packingCharge]);

  const handleChargesChange = (e, type) => {
    let charges = e.target.value;
    if (charges === ".") charges = "0.";
    if (!/^\d*\.?\d{0,2}$/.test(charges)) return;
    if (type === "delivery") {
      setDeliveryChargesLocal(charges);
    } else {
      setPackingChargesLocal(charges);
    }
  };

  // Fetch slots from API when the drawer opens, so the instant slot id
  // is available even when Instant mode is selected
  useEffect(() => {
    if (!open) {
      return;
    }
    setSlotsLoading(true);

    const initialDate = date;
    const dayStart = moment(initialDate).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
    const dayEnd = moment(initialDate).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
    const instantDate = moment(initialDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss");

    const payload = {
      slotStartTime: dayStart,
      slotEndTime: dayEnd,
      slotIsDeletedList: [false],
      sourceIdList: [orgId],
      sourceLocationIdList: [locId],
      sortByStartTime: "ASCENDING",
      isRequiredInstantDelivery: true,
      instantDeliveryDate: instantDate,
    };

    filterCutoff(payload)
      .then((res) => {
        const resArray = res?.data?.data?.results;
        const slots =
          resArray?.map((item) => ({
            slotId: item?.slot?.slotId,
            startTime: convertToLocalTime(item?.slot?.startTime),
            endTime: convertToLocalTime(item?.slot?.endTime),
            startTimeUtc: item?.slot?.startTime,
            endTimeUtc: item?.slot?.endTime,
            selected: false,
            date: item?.slot?.day,
            cutoffId: item?.cutoffId,
          })) || [];

        // instantDeliveryResults can be an object or an array depending on the backend
        const instantResults = res?.data?.data?.instantDeliveryResults;
        const instantDelivery = Array.isArray(instantResults)
          ? instantResults?.[0]
          : instantResults;
        if (instantDelivery?.instantDeliveryId) {
          // Times may come as "HH:mm:ss" only — combine with instantDeliveryDate
          const toDateTime = (time) =>
            time && !time.includes("T") && instantDelivery?.instantDeliveryDate
              ? `${instantDelivery?.instantDeliveryDate}T${time}`
              : time;
          const startUtc = toDateTime(instantDelivery?.instantDeliveryStartTime);
          const endUtc = toDateTime(instantDelivery?.instantDeliveryEndTime);
          const item = {
            slotId: instantDelivery?.instantDeliveryId,
            startTime: convertToLocalTime(startUtc),
            endTime: convertToLocalTime(endUtc),
            startTimeUtc: startUtc,
            endTimeUtc: endUtc,
            active: instantDelivery?.active,
            selected: false,
            instant: true,
          };
          slots?.unshift(item);
        }

        if (
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.es > 0
        ) {
          showSnackbar(res?.data?.data?.message || "Error while Fetching slots", "error");
          setSlotsLoading(false);
          return;
        }

        setSlotList(slots);
        setSlotsLoading(false);
      })
      .catch((err) => {
        showSnackbar(
          err?.message || (typeof err === "string" ? err : "Unable to Fetch Slots"),
          "error"
        );
        setSlotsLoading(false);
      });
  }, [date, orgId, locId, open]);

  const generateDateChips = () => {
    const today = new Date();
    const options = { weekday: "short", day: "numeric", month: "short" };
    const chips = [];

    for (let i = 0; i < 10; i++) {
      const chipDate = new Date(today);
      chipDate?.setDate(today?.getDate() + i);

      let label;
      if (i === 0) {
        label = "Today";
      } else if (i === 1) {
        label = "Tomorrow";
      } else {
        label = chipDate.toLocaleDateString("en-US", options);
      }
      chips.push({ date: label, actualDate: chipDate });
    }
    return chips;
  };

  const dateChips = generateDateChips();

  const handleDate = (chipDate) => {
    setDate(chipDate);
    setSelectedSlotId(null);
  };

  const isToday =
    date.getFullYear() === new Date().getFullYear() &&
    date.getMonth() === new Date().getMonth() &&
    date.getDate() === new Date().getDate();

  const currentUtcTime = moment.utc();
  const filteredSlots = isToday
    ? slotList?.filter((slot) => moment.utc(slot?.endTimeUtc).isAfter(currentUtcTime))
    : slotList;

  //Payload for the Grocery or other retail type
  let retailPayload = {
    userName: null,
    userId: null,
    mobileNo: null,
    createdBy: retailUserLocalStorageData?.firstName,
    locationId: locId || "",
    sourceId: orgId || "",
    loggedInUser: retailUserLocalStorageData?.uidx,
    sourceLocationId: locId || "",
    sourceType: "RETAIL",
    sourceApp: saleMode === "delivery" ? "PALLET_RETAIL" : "PALLET_POS",
    destinationId: orgId || "",
    destinationLocationId: locId || "",
    destinationType: "RETAIL",
    comments: null,
    sessionId: sessionId || null,
    orderType: saleMode === "delivery" ? "B2C_ORDER" : "POS_ORDER",
    subOrderType: isMobile ? "MPOS_ORDER" : "POS_ORDER",
    licenseId: licenseId || null,
    hoId: null,
    channel: "POS",
    cartId: cartId || null,
    terminalName: licenseName || null,
    isTaxMasterEnabled: true,
  };

  //Payload for Restaurant retail type
  // Set subOrderType to QSR_DINE_IN for QSR branch with DINE_IN sale mode
  const restaurantSubOrderType =
    branchSubType === "QSR" && saleMode === "DINE_IN" ? "QSR_DINE_IN" : saleMode;

  let tableId = "";

  if (branchSubType === "QSR") {
    tableId = "1";
  } else {
    if (saleMode === "DINE_IN") {
      tableId = selectedTable?.metadata?.tableMetadataId || "1";
    } else if (saleMode === "TAKE_AWAY") {
      tableId = "TAKE_AWAY";
    } else {
      tableId = "DELIVERY";
    }
  }

  let restaurantPayload = {
    cartId: null,
    userName: null,
    userId: null,
    tableNumber:
      saleMode === "DINE_IN"
        ? selectedTable?.tableNoForDisplay || selectedTable?.metadata?.tableName || "1"
        : "1",
    layoutId: saleMode === "DINE_IN" ? selectedTable?.layoutId : null,
    tableId: tableId,
    layoutName: saleMode === "DINE_IN" ? selectedTable?.layoutName : null,
    mobileNo: null,
    enableWhatsapp: true,
    createdBy: retailUserLocalStorageData?.uidx,
    createdByName: retailUserLocalStorageData?.firstName,
    updatedBy: retailUserLocalStorageData?.uidx,
    updatedByName: retailUserLocalStorageData?.firstName,
    locationId: locId || "",
    sourceId: orgId || "",
    licenseId: licenseId || null,
    terminalName: licenseName || null,
    orderType: "RESTAURANT_ORDER",
    subOrderType: restaurantSubOrderType,
    sourceLocationId: locId || "",
    sourceType: "RETAIL",
    channel: "POS",
    loggedInUser: retailUserLocalStorageData?.uidx,
    sourceApp: "PALLET_POS",
    destinationId: orgId || "",
    destinationLocationId: locId || "",
    destinationType: "RETAIL",
    sessionId: sessionId || null,
    isTaxMasterEnabled: true,
  };

  //Handling table booking
  const handleTableBooking = (cartIdFromResp) => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const seconds = String(today.getSeconds()).padStart(2, "0");
    const startTime = `${hours}:${minutes}:${seconds}`;

    //Getting end time
    const endDate = new Date(today); // clone the date
    endDate.setHours(endDate.getHours() + 1);

    const endHours = String(endDate.getHours()).padStart(2, "0");
    const endMinutes = String(endDate.getMinutes()).padStart(2, "0");
    const endSeconds = String(endDate.getSeconds()).padStart(2, "0");
    const endTime = `${endHours}:${endMinutes}:${endSeconds}`;

    const tableBookingPayload = {
      orgId: orgId,
      locationId: locId,
      slotDate: formattedDate,
      startTime: startTime,
      endTime: endTime,
      customerName: "",
      customerPhone: "",
      customerEmail: "",
      totalMembers: selectedTable?.metadata?.capacity,
      bookingSource: "WALKIN",
      createdBy: retailUserLocalStorageData?.firstName,
      selectedTableId: selectedTable?.metadata?.tableMetadataId,
      cartId: cartIdFromResp || "",
    };
    manualTableReservation(tableBookingPayload)
      .then((res) => {
        //Handling success error
        if (
          res?.data?.es > 0 ||
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.message || "Unable to select table", "error");
          // setTableSelectionLoader(false);
          return;
        }
        showSnackbar("Table suceessfully booked", "success");
        // setTableSelectionLoader(false);
      })
      .catch((err) => {
        // setTableSelectionLoader(false);
      });
  };

  //SKip adding customer (Handles skip button)
  const handleClose = () => {
    if (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY") {
      if (pickupMode === "slot" && !selectedSlotId) {
        showSnackbar("Please select a slot before proceeding", "warning");
        return;
      }
      const selectedSlot =
        pickupMode === "instant"
          ? slotList?.find((slot) => slot?.instant)
          : slotList?.find((slot) => slot?.slotId === selectedSlotId);
      setSlotDetails({
        slotId: selectedSlot?.slotId || "",
        startTime: selectedSlot?.startTimeUtc || "",
        endTime: selectedSlot?.endTimeUtc || "",
        cutoffId: selectedSlot?.cutoffId || "",
      });
    } else {
      setSlotDetails({
        slotId: "",
        startTime: "",
        endTime: "",
        cutoffId: "",
      });
    }

    customEventTrigger("pos_skip_button");
    // setCustomerActionButton("");
    setSkipModelLoader(true);
    setCustomerLoader(true);

    //If retailType is RESTAURANT then this restaurantCreateCart api will call to create cart
    if (retailType === "RESTAURANT") {
      restaurantPayload.deliveryCharges = deliveryCharges ? Number(deliveryCharges) : 0;
      restaurantPayload.packingCharges = packingCharges ? Number(packingCharges) : 0;
      //Restaruant API for create cart
      restaurantCreateCart(restaurantPayload)
        .then((res) => {
          if (
            res?.data?.status === "error" ||
            res?.data?.status === "ERROR" ||
            res?.data?.data?.es > 0
          ) {
            const errMsg = res?.data?.message || res?.data?.data?.message || "";
            if (isStaleCartError(errMsg)) {
              clearStaleCartStorage();
              setCartId(null);
              setCartItems([]);
              setCustomerLoader(false);
              showStaleCartDialog();
              return;
            }
            showSnackbar(errMsg || "Something went wrong while creating cart", "error");
            setCustomerLoader(false);
            return;
          }
          const customer_details = {
            name: null,
            mobileNumber: null,
            uidx: null,
            whatsapp: false,
          };
          //creating orderMetricData
          if (!cartItems?.length) {
            //Storing current time to send into event tracker
            const currentTime = new Date().getTime();
            dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
            dispatch(changePrevAddedTime(currentTime));
            //Creating Order Metric Data
            const orderMetricData = {
              startTime: currentTime,
              prevAddedProductTime: currentTime,
              startTimeAdded: true,
              manuallyAdded: 0,
              scannedProduct: 0,
              isMultipleBatch: false,
              avgProductAddTime: "",
              totalProducts: 0,
              productTimeArray: [],
              editOrderItem: 0,
              manuallyRemovedItems: 0,
              manualItemsGtin: [],
            };
            localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
          }
          showSnackbar("Cart Added successfully", "success");
          setCartId(res?.data?.data?.data?.cartId);
          setCartItems(res?.data?.data?.data?.cartProducts || []);
          setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing.sgst);
          setCess(res?.data?.data?.data?.billing.totalCessAmount);
          setSubTotal(res?.data?.data?.data?.billing.totalCartValue);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          if (setDeliveryCharge)
            setDeliveryCharge(res?.data?.data?.data?.billing?.deliveryCharges || 0);
          if (setPackingCharge)
            setPackingCharge(res?.data?.data?.data?.billing?.packingCharges || 0);
          if (retailType === "RESTAURANT") {
            if (res?.data?.data?.data?.subOrderType === "QSR_DINE_IN") {
              setSaleMode("DINE_IN");
            } else {
              setSaleMode(res?.data?.data?.data?.subOrderType);
            }
          } else {
            setSaleMode(res?.data?.data?.data?.subOrderType);
          }
          setTotalValue(res?.data?.data?.data?.billing?.totalValue);
          setSkipModelLoader(false);
          setAdjustCheck(false);
          setCustomerMobile("");
          setSplitActive(false);
          setPartailStatus(false);
          //Stroing cartId and other data to local storage
          localStorage.setItem("CartId", res?.data?.data?.data?.cartId);
          localStorage.setItem("sessionId", sessionId);
          localStorage.setItem("licenseId", licenseId);
          localStorage.setItem("customer_details", JSON.stringify(customer_details));
          if (branchSubType === "FINE_DINE") {
            localStorage.setItem("fineDineSaleMode", saleMode);
          }
          setCustomerName("");
          setCustomerMobileNumber("");
          localStorage.removeItem("loyaltyDetails");
          localStorage.removeItem("cartOrderType");
          localStorage.removeItem("b2bPartnerName");
          setCustomerLoader(false);
          isMobilePos &&
            emit({
              type: "localData",
              data: {
                CartId: res?.data?.data?.data?.cartId,
                customer_details: customer_details,
              },
            });
          if (
            retailType === "RESTAURANT" &&
            saleMode === "DINE_IN" &&
            branchSubType === "FINE_DINE"
          ) {
            handleTableBooking(res?.data?.data?.data?.cartId);
          }
        })
        .catch((err) => {
          const errMsg = err?.response?.data?.message || err?.message || "";
          if (isStaleCartError(errMsg)) {
            clearStaleCartStorage();
            setCartId(null);
            setCartItems([]);
            setCustomerLoader(false);
            showStaleCartDialog();
            return;
          }
          showSnackbar(errMsg, "error");
          setCustomerLoader(false);
        })
        .finally(() => {
          setSkipModelLoader(false);
        });
    } else {
      //If retailType not RESTAURANT then this restaurantCreateCart api will call to create cart
      SkipUserFun(retailPayload)
        .then((res) => {
          if (
            res?.data?.status === "error" ||
            res?.data?.status === "ERROR" ||
            res?.data?.data?.es > 0
          ) {
            const errMsg = res?.data?.message || res?.data?.data?.message || "";
            if (isStaleCartError(errMsg)) {
              clearStaleCartStorage();
              setCartId(null);
              setCartItems([]);
              setCustomerLoader(false);
              showStaleCartDialog();
              return;
            }
            showSnackbar(errMsg || "Something went wrong while creating cart", "error");
            setCustomerLoader(false);
            return;
          }
          const customer_details = {
            name: null,
            mobileNumber: null,
            uidx: null,
            whatsapp: false,
          };
          //creating orderMetricData
          if (!cartItems?.length) {
            const currentTime = new Date().getTime();
            dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
            dispatch(changePrevAddedTime(currentTime));
            const orderMetricData = {
              startTime: currentTime,
              prevAddedProductTime: currentTime,
              startTimeAdded: true,
              manuallyAdded: 0,
              scannedProduct: 0,
              isMultipleBatch: false,
              avgProductAddTime: "",
              totalProducts: 0,
              productTimeArray: [],
              editOrderItem: 0,
              manuallyRemovedItems: 0,
              manualItemsGtin: [],
            };
            localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
          }
          showSnackbar("Cart Added success", "success");
          setCartId(res?.data?.data?.cartId);
          setCartItems(res?.data?.data?.cartProducts || []);
          setCartTotalQty(res?.data?.data?.billing?.quantity);
          setCgst(res?.data?.data?.billing?.cgst);
          setSgst(res.data.data.billing.sgst);
          setCess(res.data.data.billing.totalCessAmount);
          setSubTotal(res.data.data.billing.totalCartValue);
          setTotal(res?.data?.data?.billing?.totalCartValue);
          setSkipModelLoader(false);
          setAdjustCheck(false);
          setCustomerMobile("");
          setSplitActive(false);
          setPartailStatus(false);
          localStorage.setItem("CartId", res?.data?.data?.cartId);
          localStorage.setItem("sessionId", sessionId);
          localStorage.setItem("licenseId", licenseId);
          localStorage.setItem("customer_details", JSON.stringify(customer_details));
          localStorage.removeItem("loyaltyDetails");
          localStorage.removeItem("cartOrderType");
          localStorage.removeItem("b2bPartnerName");
          setCustomerLoader(false);
          isMobilePos &&
            emit({
              type: "localData",
              data: {
                CartId: res.data.data.cartId,
                customer_details: customer_details,
              },
            });
        })
        .catch((err) => {
          const errMsg = err?.response?.data?.message || err?.message || "";
          if (isStaleCartError(errMsg)) {
            clearStaleCartStorage();
            setCartId(null);
            setCartItems([]);
            setCustomerLoader(false);
            showStaleCartDialog();
            return;
          }
          showSnackbar(errMsg, "error");
          setCustomerLoader(false);
        })
        .finally(() => {
          setSkipModelLoader(false);
        });
    }
    setName("");
    setOpenCartCustomerDetail(false);
  };

  //Adding Customer to the cart (or add new cart with customer infomration, Handles Add Customer Button)
  const addCustomerFun = () => {
    if (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY") {
      if (pickupMode === "slot" && !selectedSlotId) {
        showSnackbar("Please select a slot before proceeding", "warning");
        return;
      }
      const selectedSlot =
        pickupMode === "instant"
          ? slotList?.find((slot) => slot?.instant)
          : slotList?.find((slot) => slot?.slotId === selectedSlotId);
      setSlotDetails({
        slotId: selectedSlot?.slotId || "",
        startTime: selectedSlot?.startTimeUtc || "",
        endTime: selectedSlot?.endTimeUtc || "",
        cutoffId: selectedSlot?.cutoffId || "",
      });
    } else {
      setSlotDetails({
        slotId: "",
        startTime: "",
        endTime: "",
        cutoffId: "",
      });
    }

    // setCustomerActionButton("");
    setCustomerLoader(true);
    let addCustomerPayload = {
      mobile: customerMobileNumber,
      firstName: customerName,
      countryCode: removePlusSign(selectedCountry.value),
      tenantId: locId,
    };
    customEventTrigger("pos_customer_contact_added", {
      mobile_number: addCustomerPayload.mobile,
    });
    //Mobile number validator
    if (customerMobileNumber?.length !== 10 && selectedCountry.value == "+91") {
      showSnackbar("Enter a valid mobile number", "error");
    } else {
      setAddModelLoader(true);
      //Calling addCustomer API to create the customer
      addCustomer(addCustomerPayload).then((response) => {
        let customerUidxData = {
          uidx: response?.data?.data?.uidx,
          phoneNumber: customerMobileNumber,
          name: response?.data?.data?.firstName,
          organizationId: orgId,
          createdBy: retailUserLocalStorageData.uidx,
          locationId: locId,
          sessionId: sessionId,
          platform: "POS"
        };
        //API to link the customer to the curent cart or session
        /*
        AddedCustomerData(customerUidxData)
          .then((resp) => {
        */
        createB2CcustomerApi(customerUidxData)
          .then((resp) => {
            if (retailType === "RESTAURANT") {
              restaurantPayload.userName = response?.data?.data?.firstName;
              restaurantPayload.mobileNo = customerMobileNumber;
              restaurantPayload.userId = customerUidxData?.uidx;
              restaurantPayload.cartId = cartId || null;
              restaurantPayload.deliveryCharges = deliveryCharges ? Number(deliveryCharges) : 0;
              restaurantPayload.packingCharges = packingCharges ? Number(packingCharges) : 0;

              //API to create the cart or update the cart when customer is added.
              restaurantCreateCart(restaurantPayload)
                .then((res) => {
                  if (
                    res?.data?.status === "error" ||
                    res?.data?.status === "ERROR" ||
                    res?.data?.data?.es > 0
                  ) {
                    showSnackbar(
                      res?.data?.message ||
                        res?.data?.data?.message ||
                        "Something went wrong while creating cart",
                      "error"
                    );
                    setCustomerLoader(false);
                    return;
                  }
                  const customer_details = {
                    name: response?.data?.data?.firstName,
                    mobileNumber: customerMobileNumber,
                    uidx: response?.data?.data?.uidx,
                    email: response?.data?.data?.email || foundCustomer?.email,
                    countryCode: response?.data?.data?.countryCode || foundCustomer?.countryCode,
                    whatsapp: whatsAppCheck,
                  };
                  //creating order matric data
                  if (!cartItems?.length) {
                    const currentTime = new Date().getTime();
                    dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
                    dispatch(changePrevAddedTime(currentTime));
                    const orderMetricData = {
                      startTime: currentTime,
                      prevAddedProductTime: currentTime,
                      startTimeAdded: true,
                      manuallyAdded: 0,
                      scannedProduct: 0,
                      isMultipleBatch: false,
                      avgProductAddTime: "",
                      totalProducts: 0,
                      productTimeArray: [],
                      editOrderItem: 0,
                      manuallyRemovedItems: 0,
                      manualItemsGtin: [],
                    };
                    localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
                  }
                  showSnackbar("Customer added success to cart", "success");
                  setCartId(res?.data?.data?.data?.cartId);
                  setCartItems(res?.data?.data?.data?.cartProducts);
                  setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
                  setCgst(res?.data?.data?.data?.billing?.cgst);
                  setSgst(res?.data?.data?.data?.billing?.sgst);
                  setCess(res?.data?.data?.data?.billing.totalCessAmount);
                  setSubTotal(res?.data?.data?.data?.billing?.totalCartValue);
                  setTotal(res?.data?.data?.data?.billing?.totalCartValue);
                  if (setDeliveryCharge)
                    setDeliveryCharge(res?.data?.data?.data?.billing?.deliveryCharges || 0);
                  if (setPackingCharge)
                    setPackingCharge(res?.data?.data?.data?.billing?.packingCharges || 0);
                  if (retailType === "RESTAURANT") {
                    if (res?.data?.data?.data?.subOrderType === "QSR_DINE_IN") {
                      setSaleMode("DINE_IN");
                    } else {
                      setSaleMode(res?.data?.data?.data?.subOrderType);
                    }
                  } else {
                    setSaleMode(res?.data?.data?.data?.subOrderType);
                  }
                  setTotalValue(res?.data?.data?.data?.billing?.totalValue);
                  retailPayload.userName = null;
                  retailPayload.mobileNo = null;
                  retailPayload.userId = null;
                  localStorage.setItem("CartId", res?.data?.data?.data?.cartId);
                  localStorage.setItem("customer_details", JSON.stringify(customer_details));
                  localStorage.setItem("customerId", resp?.data?.retailCustomer?.id);
                  localStorage.removeItem("cartOrderType");
                  localStorage.removeItem("b2bPartnerName");

                  // Attach delivery address to cart if DELIVERY mode
                  if (saleMode === "DELIVERY") {
                    const newCartId = res?.data?.data?.data?.cartId;
                    const now = new Date().toISOString();
                    const buildAddrPayload = (addr) => ({
                      cartId: newCartId,
                      sourceLocationId: locId,
                      updatedBy: retailUserDetails?.uidx || "",
                      updatedByName: user_name || "",
                      orderType: retailType === "RESTAURANT" ? "RESTAURANT_ORDER" : "POS_ORDER",
                      destinationLocationId: locId,
                      loggedInUser: retailUserDetails?.uidx || "",
                      billingAddress: {
                        addressId: String(addr?.addressId || ""),
                        country: addr?.country || "India",
                        state: addr?.state || "",
                        city: addr?.city || "",
                        longitude: String(addr?.longitude || 0),
                        latitude: String(addr?.latitude || 0),
                        pinCode: addr?.pincode || "",
                        phoneNo: addr?.phoneNumber || "",
                        addressLine1: addr?.addressLine1 || "",
                        addressLine2: addr?.addressLine2 || "",
                        type: addr?.addressType || "",
                        addressType: addr?.addressType || "",
                        landmark: addr?.landmark || "",
                        updatedBy: retailUserDetails?.uidx || "",
                        updatedOn: now,
                        ...(addr?.addressType === "OTHER" && { otherName: addr?.otherName }),
                      },
                      shippingAddress: {
                        addressId: String(addr?.addressId || ""),
                        country: addr?.country || "India",
                        state: addr?.state || "",
                        city: addr?.city || "",
                        longitude: String(addr?.longitude || 0),
                        latitude: String(addr?.latitude || 0),
                        pinCode: addr?.pincode || "",
                        phoneNo: addr?.phoneNumber || "",
                        addressLine1: addr?.addressLine1 || "",
                        addressLine2: addr?.addressLine2 || "",
                        type: addr?.addressType || "",
                        addressType: addr?.addressType || "",
                        landmark: addr?.landmark || "",
                        updatedBy: retailUserDetails?.uidx || "",
                        updatedOn: now,
                        ...(addr?.addressType === "OTHER" && { otherName: addr?.otherName }),
                      },
                    });

                    if (selectedDeliveryAddress) {
                      customer_details.selectedAddressId = selectedDeliveryAddress?.addressId;
                      localStorage.setItem("customer_details", JSON.stringify(customer_details));
                      restaurantCartUpdate(buildAddrPayload(selectedDeliveryAddress)).catch(
                        () => {}
                      );
                    }
                  }

                  isMobilePos &&
                    emit({
                      type: "localData",
                      data: {
                        CartId: res?.data?.data?.data?.cartId,
                        customer_details: customer_details,
                      },
                    });
                  setCustomerMobile(customerMobileNumber);
                  setCustomerSuccess(true);
                  setCustomerName("");
                  setCustomerMobileNumber("");
                  setAdjustCheck(false);
                  setAddModelLoader(false);
                  setSplitActive(false);
                  setPartailStatus(false);
                  setCustomerLoader(false);
                  //payload for loyalty points
                  const loyaltyPayload = {
                    customerType: "END_CUSTOMER",
                    customerId: customerUidxData?.uidx,
                    sourceOrgId: orgId,
                    platformSupportType: "B2C",
                  };
                  //API for Loyalty point
                  getLoyaltyInfo(loyaltyPayload).then((response) => {
                    const res = response?.data?.data?.data;
                    if (!res) {
                      removeFromLocalStorage("loyaltyDetails");
                    }
                    const loyaltyDetails = {
                      totalLoyalty: res?.totalAvailablePoint,
                      totalLoyaltyValue: res?.totalAvailablePointValue,
                    };
                    setInLocalStorage("loyaltyDetails", loyaltyDetails);
                  });
                })
                .catch((err) => {
                  const errMsg = err?.response?.data?.message || err?.message || "";
                  if (isStaleCartError(errMsg)) {
                    clearStaleCartStorage();
                    setCartId(null);
                    setCartItems([]);
                    setAddModelLoader(false);
                    setCustomerLoader(false);
                    showStaleCartDialog();
                    return;
                  }
                  showSnackbar(errMsg, "error");
                  setAddModelLoader(false);
                  setCustomerLoader(false);
                })
                .finally(() => {
                  setAddModelLoader(false);
                });
            } else {
              //Creating customer when retailType is not restaurant
              retailPayload.userName = customerName;
              retailPayload.mobileNo = customerMobileNumber;
              retailPayload.userId = customerUidxData?.uidx;
              //API for create Cart
              SkipUserFun(retailPayload)
                .then((res) => {
                  if (
                    res?.data?.status === "error" ||
                    res?.data?.status === "ERROR" ||
                    res?.data?.data?.es > 0
                  ) {
                    showSnackbar(
                      res?.data?.message ||
                        res?.data?.data?.message ||
                        "Something went wrong while creating cart",
                      "error"
                    );
                    setCustomerLoader(false);
                    return;
                  }
                  const customer_details = {
                    name: response?.data?.data?.firstName,
                    mobileNumber: customerMobileNumber,
                    uidx: response?.data?.data?.uidx,
                    email: response?.data?.data?.email || foundCustomer?.email,
                    countryCode: response?.data?.data?.countryCode || foundCustomer?.countryCode,
                    whatsapp: whatsAppCheck,
                  };
                  if (!cartItems?.length) {
                    const currentTime = new Date().getTime();
                    dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
                    dispatch(changePrevAddedTime(currentTime));
                    const orderMetricData = {
                      startTime: currentTime,
                      prevAddedProductTime: currentTime,
                      startTimeAdded: true,
                      manuallyAdded: 0,
                      scannedProduct: 0,
                      isMultipleBatch: false,
                      avgProductAddTime: "",
                      totalProducts: 0,
                      productTimeArray: [],
                      editOrderItem: 0,
                      manuallyRemovedItems: 0,
                      manualItemsGtin: [],
                    };
                    localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
                  }
                  showSnackbar("Customer added success to cart", "success");
                  setCartId(res?.data?.data?.cartId);
                  setCartItems(res?.data?.data?.cartProducts);
                  setCartTotalQty(res?.data?.data?.billing?.quantity);
                  setCgst(res?.data?.data?.billing?.cgst);
                  setSgst(res?.data?.data?.billing?.sgst);
                  setCess(res.data.data.billing.totalCessAmount);
                  setSubTotal(res?.data?.data?.billing?.totalCartValue);
                  setTotal(res?.data?.data?.billing?.totalCartValue);
                  retailPayload.userName = null;
                  retailPayload.mobileNo = null;
                  retailPayload.userId = null;
                  localStorage.setItem("CartId", res?.data?.data?.cartId);
                  localStorage.setItem("customer_details", JSON.stringify(customer_details));
                  localStorage.removeItem("cartOrderType");
                  localStorage.removeItem("b2bPartnerName");
                  isMobilePos &&
                    emit({
                      type: "localData",
                      data: {
                        CartId: res?.data?.data?.cartId,
                        customer_details: customer_details,
                      },
                    });
                  setCustomerMobile(customerMobileNumber);
                  setCustomerSuccess(true);
                  setCustomerName("");
                  setCustomerMobileNumber("");
                  setAdjustCheck(false);
                  setAddModelLoader(false);
                  setSplitActive(false);
                  setPartailStatus(false);
                  setCustomerLoader(false);
                  const loyaltyPayload = {
                    customerType: "END_CUSTOMER",
                    customerId: customerUidxData?.uidx,
                    sourceOrgId: orgId,
                    platformSupportType: "B2C",
                  };
                  getLoyaltyInfo(loyaltyPayload).then((response) => {
                    const res = response?.data?.data?.data;
                    if (!res) {
                      removeFromLocalStorage("loyaltyDetails");
                    }
                    const loyaltyDetails = {
                      totalLoyalty: res?.totalAvailablePoint,
                      totalLoyaltyValue: res?.totalAvailablePointValue,
                    };
                    setInLocalStorage("loyaltyDetails", loyaltyDetails);
                  });
                })
                .catch((err) => {
                  const errMsg = err?.response?.data?.message || err?.message || "";
                  if (isStaleCartError(errMsg)) {
                    clearStaleCartStorage();
                    setCartId(null);
                    setCartItems([]);
                    setAddModelLoader(false);
                    setCustomerLoader(false);
                    showStaleCartDialog();
                    return;
                  }
                  showSnackbar(errMsg, "error");
                  setAddModelLoader(false);
                  setCustomerLoader(false);
                })
                .finally(() => {
                  setAddModelLoader(false);
                });
            }
            // setCustomerName("Manesh");
          })
          .catch((err) => {
            showSnackbar(err?.response?.data?.message || err?.message, "error");
            setCustomerLoader(false);
          })
          .finally(() => {
            setSkipModelLoader(false);
          });
      });
    }
    setName(customerName);
    setOpenCartCustomerDetail(false);
  };

  /**
   * Action handle for skip or add customer in DINE_IN
   */
  // const actionHandlerForDineIn = (action) => {
  //   if (action === "SKIP_CUSTOMER") {
  //     setSelectedTable({});
  //     setCustomerActionButton("SKIP_CUSTOMER");
  //     navigate("/products/table-layout");
  //   } else if (action === "ADD_CUSTOMER") {
  //     setSelectedTable({});
  //     setCustomerActionButton("ADD_CUSTOMER");
  //     navigate("/products/table-layout");
  //   }
  // };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (customerMobileNumber !== "" || saleMode === "delivery") {
        addCustomerFun();
      } else {
        handleClose();
      }
    }
  };

  //Storing the selected country details in the selectedCountry state
  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  function removePlusSign(input) {
    if (typeof input !== "string") {
      return input;
    }
    if (input.startsWith("+")) {
      return input.slice(1);
    }
    return input;
  }

  //String seleceted sales mode in the state
  const handleOptionChange = (event) => {
    const value = event.target.value;
    if (branchSubType === "FINE_DINE" && value === "DINE_IN") {
      setSaleMode("DINE_IN");
      localStorage.removeItem("fineDineSaleMode");
      setOpenCartCustomerDetail(false);
      navigate("/products/table-layout");
      return;
    }
    setSaleMode(value);
    if (value === "DELIVERY" || value === "TAKE_AWAY") {
      localStorage.setItem("fineDineSaleMode", value);
    }
  };

  useEffect(() => {
    if (open) {
      setPickupMode(slotDetails?.slotId ? "slot" : "instant");
      setDate(slotDetails?.startTime ? new Date(slotDetails?.startTime) : new Date());
      setSelectedSlotId(slotDetails?.slotId || null);
    }
  }, [open, slotDetails]);

  useEffect(() => {
    if (open) {
      const storedCustomer = JSON.parse(localStorage.getItem("customer_details"));

      if (storedCustomer) {
        setCustomerName(storedCustomer?.name || "");
        setCustomerMobileNumber(storedCustomer?.mobileNumber || "");
      } else {
        setCustomerName("");
        setCustomerMobileNumber("");
      }
    }
  }, [open]);

  useEffect(() => {
    const isIndian = selectedCountry?.value === "+91";
    const isValidLength = isIndian
      ? customerMobileNumber?.length === 10
      : customerMobileNumber?.length >= 4;
    if (!isValidLength) {
      setCustomerFound(false);
      setCustomerUidx(null);
      setCustomerId(null);
      setFoundCustomer(null);
      if (!customerMobileNumber) {
        setCustomerName("");
      }
      return;
    }
    let stale = false;
    setCustomerSearchLoader(true);
    setCustomerFound(false);
    setCustomerUidx(null);
    setCustomerId(null);
    setFoundCustomer(null);
    if (saleMode === "DELIVERY") {
      setAddressFetchLoader(true);
    }
    /*
    customerSearch({ orgId, pageNo: 0, pageSize: 1, mobile: customerMobileNumber })
    */
    customerSearchV2Api({
      organizationId: orgId,
      search: customerMobileNumber,
      pageNumber: 0,
      pageSize: 1,
    })
      .then((res) => {
        if (stale) return;
        setCustomerSearchLoader(false);
        const found = res?.data?.customers?.[0];
        if (!found) {
          setCustomerUidx(null);
          setCustomerId(null);
          setCustomerName("");
          setFoundCustomer(null);
          if (saleMode === "DELIVERY") {
            setAddressFetchLoader(false);
            setShowAddressForm(true);
          }
          return;
        }
        setCustomerFound(true);
        setCustomerUidx(found?.uidx || found?.id);
        setCustomerId(found?.id);
        setCustomerName(found?.firstName || found?.name || "");
        setFoundCustomer(found);
      })
      .catch(() => {
        if (!stale) {
          setCustomerSearchLoader(false);
          setCustomerName("");
        }
      });
    return () => {
      stale = true;
    };
  }, [customerMobileNumber, selectedCountry]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchSavedAddresses = (cid = customerId) => {
    if (!cid) return;
    setAddressFetchLoader(true);
    getAddress(cid)
      .then((res) => {
        const addresses = res?.data?.addresses || [];
        if (addresses?.length <= 0) {
          setShowAddressForm(true);
        } else {
          // If there is a selected address, or if we were editing one, let's update selectedDeliveryAddress with the new values
          if (selectedDeliveryAddress) {
            const matched = addresses?.find(
              (addr) => String(addr?.addressId) === String(selectedDeliveryAddress?.addressId)
            );
            if (matched) {
              setSelectedDeliveryAddress(matched);
            }
          } else {
            const storedCustomer = JSON.parse(localStorage.getItem("customer_details"));
            if (storedCustomer && storedCustomer?.selectedAddressId) {
              const matchedAddress = addresses?.find(
                (addr) => String(addr?.addressId) === String(storedCustomer?.selectedAddressId)
              );
              if (matchedAddress) {
                setSelectedDeliveryAddress(matchedAddress);
              }
            }
          }
        }
        setSavedAddresses(addresses);
        setAddressFetchLoader(false);
      })
      .catch(() => {
        setSavedAddresses([]);
        setAddressFetchLoader(false);
      });
  };

  // Fetch saved delivery addresses when an existing customer is found and DELIVERY is selected
  useEffect(() => {
    if (saleMode === "DELIVERY" && customerUidx) {
      setSavedAddresses([]);
      setSelectedDeliveryAddress(null);
      setShowAddressForm(false);
      fetchSavedAddresses(customerId);
    } else if (saleMode !== "DELIVERY") {
      setSavedAddresses([]);
      setSelectedDeliveryAddress(null);
      setShowAddressForm(false);
    } else {
      // DELIVERY mode but no customer identified – clear stale addresses
      setSavedAddresses([]);
      setSelectedDeliveryAddress(null);
      setShowAddressForm(true);
    }
  }, [saleMode, customerUidx, customerId]); // eslint-disable-line react-hooks/exhaustive-deps

  const syncCartAddressWithUpdatedAddress = (updatedAddr) => {
    const activeCartId = cartId || localStorage.getItem("CartId");
    if (!activeCartId || !updatedAddr) return;

    const now = new Date().toISOString();
    const buildPayload = (addr) => ({
      cartId: activeCartId,
      updatedBy: retailUserDetails?.uidx || "",
      updatedByName: user_name || "",
      sourceLocationId: locId,
      orderType: retailType === "RESTAURANT" ? "RESTAURANT_ORDER" : "POS_ORDER",
      destinationLocationId: locId,
      loggedInUser: retailUserDetails?.uidx || "",
      billingAddress: {
        addressId: String(addr?.addressId || ""),
        country: addr?.country || "India",
        state: addr?.state || "",
        city: addr?.city || "",
        longitude: String(addr?.longitude || 0),
        latitude: String(addr?.latitude || 0),
        pinCode: addr?.pincode || "",
        phoneNo: addr?.phoneNumber || "",
        addressLine1: addr?.addressLine1 || "",
        addressLine2: addr?.addressLine2 || "",
        type: addr?.addressType || "",
        addressType: addr?.addressType || "",
        landmark: addr?.landmark || "",
        updatedBy: retailUserDetails?.uidx || "",
        updatedOn: now,
        ...(addr?.addressType === "OTHER" && { otherName: addr?.otherName }),
      },
      shippingAddress: {
        addressId: String(addr?.addressId || ""),
        country: addr?.country || "India",
        state: addr?.state || "",
        city: addr?.city || "",
        longitude: String(addr?.longitude || 0),
        latitude: String(addr?.latitude || 0),
        pinCode: addr?.pincode || "",
        phoneNo: addr?.phoneNumber || "",
        addressLine1: addr?.addressLine1 || "",
        addressLine2: addr?.addressLine2 || "",
        type: addr?.addressType || "",
        addressType: addr?.addressType || "",
        landmark: addr?.landmark || "",
        updatedBy: retailUserDetails?.uidx || "",
        updatedOn: now,
        ...(addr?.addressType === "OTHER" && { otherName: addr?.otherName }),
      },
    });

    restaurantCartUpdate(buildPayload(updatedAddr)).catch(() => {});
  };

  const handleCancelEdit = () => {
    setEditingAddressId(null);
    setShowAddressForm(false);
    setDeliveryAddressForm({
      addressType: "HOME",
      otherName: "",
      house: "",
      apartment: "",
      landmark: "",
      city: "",
      state: "",
      pincode: "",
      phone: "",
      latitude: null,
      longitude: null,
    });
    setAddressFormErrors({});
  };

  const handleSaveAddress = () => {
    // 1. Validate phone number and name
    if (customerMobileNumber?.length !== 10 && selectedCountry?.value == "+91") {
      showSnackbar("Enter a valid mobile number", "error");
      return;
    }

    // 2. Validate address form
    if (!validateAddressForm()) return;

    setAddModelLoader(true);

    const removePlusSignLocal = (input) => {
      if (typeof input !== "string") return input;
      return input.startsWith("+") ? input.slice(1) : input;
    };

    const saveAddressWithCustomerId = (cid) => {
      const addrPayload = {
        customerId: cid,
        addressLine1: deliveryAddressForm?.house,
        addressLine2: deliveryAddressForm?.apartment,
        city: deliveryAddressForm?.city,
        state: deliveryAddressForm?.state,
        country: "India",
        pincode: deliveryAddressForm?.pincode,
        addressType: deliveryAddressForm?.addressType,
        phoneNumber: deliveryAddressForm?.phone,
        landmark: deliveryAddressForm?.landmark,
        defaultShipping: true,
        defaultBilling: true,
        latitude: deliveryAddressForm?.latitude || 0,
        longitude: deliveryAddressForm?.longitude || 0,
        createdBy: user_name,
        ...(deliveryAddressForm?.addressType === "OTHER" && {
          otherName: deliveryAddressForm?.otherName,
        }),
      };

      createAddress(addrPayload)
        .then((res) => {
          if (
            res?.data?.status === "ERROR" ||
            res?.data?.status === "error" ||
            res?.data?.data?.es > 0 ||
            res?.data?.es > 0 ||
            res?.data?.data?.status === "ERROR" ||
            res?.data?.data?.status === "error"
          ) {
            showSnackbar(
              res?.data?.data?.message || res?.data?.message || "Unable to save address",
              "error"
            );
            return;
          }

          showSnackbar("Address saved successfully", "success");
          const newAddr = res?.data?.address || res?.data?.data?.address;

          setShowAddressForm(false);

          if (newAddr) {
            setSelectedDeliveryAddress(newAddr);
            const storedCustomer = JSON.parse(localStorage.getItem("customer_details"));
            if (storedCustomer) {
              storedCustomer.selectedAddressId = newAddr?.addressId;
              localStorage.setItem("customer_details", JSON.stringify(storedCustomer));
            }
            syncCartAddressWithUpdatedAddress(newAddr);
          }

          // Refetch saved addresses
          fetchSavedAddresses(cid);
        })
        .catch((err) => {
          showSnackbar(
            err?.response?.data?.message || err?.message || "Unable to save address",
            "error"
          );
        })
        .finally(() => {
          setAddModelLoader(false);
        });
    };

    if (customerId) {
      // Existing customer
      saveAddressWithCustomerId(customerId);
    } else {
      // New customer: create customer first
      const addCustomerPayload = {
        mobile: customerMobileNumber,
        firstName: customerName || "",
        countryCode: removePlusSignLocal(selectedCountry?.value),
        tenantId: locId,
      };

      addCustomer(addCustomerPayload)
        .then((response) => {
          const uidx = response?.data?.data?.uidx;
          if (!uidx) {
            showSnackbar("Failed to create customer record", "error");
            setAddModelLoader(false);
            return;
          }

          const customerUidxData = {
            uidx: uidx,
            phoneNumber: customerMobileNumber,
            name: response?.data?.data?.firstName || customerName,
            organizationId: orgId,
            createdBy: retailUserLocalStorageData?.uidx || retailUserDetails?.uidx,
            locationId: locId,
            sessionId: sessionId,
            platform: "POS"
          };

          /*
          AddedCustomerData(customerUidxData)
            .then((resp) => {
              const storeCustId = resp?.data?.retailCustomer?.id || uidx;
          */
          createB2CcustomerApi(customerUidxData)
            .then((resp) => {
              const storeCustId = resp?.data?.customer?.id || uidx;
              localStorage.setItem("customerId", storeCustId);

              // Set component states for found customer
              setCustomerFound(true);
              setCustomerUidx(uidx);
              setCustomerId(storeCustId);
              setFoundCustomer(response?.data?.data || null);

              // Proceed to save address
              saveAddressWithCustomerId(storeCustId);
            })
            .catch((err) => {
              showSnackbar(err?.message || "Failed to link customer", "error");
              setAddModelLoader(false);
            });
        })
        .catch((err) => {
          showSnackbar(err?.message || "Failed to create customer", "error");
          setAddModelLoader(false);
        });
    }
  };

  const handleUpdateAddressClick = () => {
    if (!validateAddressForm()) return;

    const addrPayload = {
      customerId: customerId,
      addressId: String(editingAddressId),
      addressLine1: deliveryAddressForm?.house,
      addressLine2: deliveryAddressForm?.apartment,
      city: deliveryAddressForm?.city,
      state: deliveryAddressForm?.state,
      country: "India",
      pincode: deliveryAddressForm?.pincode,
      addressType: deliveryAddressForm?.addressType,
      phoneNumber: deliveryAddressForm?.phone,
      landmark: deliveryAddressForm?.landmark,
      defaultShipping: true,
      defaultBilling: true,
      latitude: deliveryAddressForm?.latitude || 0,
      longitude: deliveryAddressForm?.longitude || 0,
      updatedBy: user_name,
      ...(deliveryAddressForm?.addressType === "OTHER" && {
        otherName: deliveryAddressForm?.otherName,
      }),
    };

    setAddModelLoader(true);
    updateAddress(addrPayload)
      .then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0 ||
          res?.data?.es > 0 ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.status === "error"
        ) {
          showSnackbar(
            res?.data?.data?.message || res?.data?.message || "Unable to update delivery address",
            "error"
          );
          setAddModelLoader(false);
          return;
        }

        showSnackbar("Address updated successfully", "success");
        const updatedAddr = res?.data?.address || res?.data?.data?.address;

        // If the edited address was the selected one, update the selectedAddress state and the cart
        if (updatedAddr) {
          if (
            selectedDeliveryAddress &&
            String(selectedDeliveryAddress?.addressId) === String(updatedAddr?.addressId)
          ) {
            setSelectedDeliveryAddress(updatedAddr);
            const storedCustomer = JSON.parse(localStorage.getItem("customer_details"));
            if (storedCustomer) {
              storedCustomer.selectedAddressId = updatedAddr?.addressId;
              localStorage.setItem("customer_details", JSON.stringify(storedCustomer));
            }
            syncCartAddressWithUpdatedAddress(updatedAddr);
          }
        }

        setEditingAddressId(null);
        setShowAddressForm(false);
        // Refetch saved addresses
        fetchSavedAddresses(customerId);
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || err?.message || "Unable to update delivery address",
          "error"
        );
      })
      .finally(() => {
        setAddModelLoader(false);
      });
  };

  const handleAddressFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "pincode" && value.length > 6) return;
    if (name === "phone" && value.length > 10) return;
    if (name === "state") {
      // Reset city whenever state changes
      setDeliveryAddressForm((prev) => ({ ...prev, state: value, city: "" }));
      setAddressFormErrors((prev) => ({ ...prev, state: "", city: "" }));
    } else {
      setDeliveryAddressForm((prev) => ({ ...prev, [name]: value }));
      setAddressFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // ── Parse a Google Place result and fill address fields ──────────────────
  // Parse a place result from the REST Places Details API and fill the address form
  const handlePlaceParsed = (result) => {
    const comps = {};
    (result.address_components || []).forEach((c) => {
      c.types.forEach((t) => {
        comps[t] = c.long_name;
      });
    });
    const houseStr =
      [comps["street_number"], comps["route"]].filter(Boolean).join(" ") ||
      result.formatted_address ||
      "";
    const cityStr = comps["locality"] || comps["administrative_area_level_2"] || "";
    const stateStr = normaliseState(comps["administrative_area_level_1"] || "");
    const pincodeStr = comps["postal_code"] || "";
    // REST API returns plain numbers, not functions
    const lat = result.geometry?.location?.lat || 0;
    const lng = result.geometry?.location?.lng || 0;
    setDeliveryAddressForm((prev) => ({
      ...prev,
      house: houseStr,
      city: cityStr,
      state: stateStr,
      pincode: pincodeStr,
      latitude: lat,
      longitude: lng,
    }));
    setAddressFormErrors((prev) => ({ ...prev, house: "", city: "", state: "", pincode: "" }));
    setCcdSuggestions([]);
    setCcdDropdownOpen(false);
  };

  // Fetch address suggestions from our server-side Places proxy
  const fetchCcdSuggestions = (value) => {
    if (ccdDebounceRef.current) clearTimeout(ccdDebounceRef.current);
    if (!value || value.length < 2) {
      setCcdSuggestions([]);
      setCcdDropdownOpen(false);
      return;
    }
    ccdDebounceRef.current = setTimeout(async () => {
      try {
        const res = await fetch(`/api/places-autocomplete?input=${encodeURIComponent(value)}`);
        const data = await res.json();
        setCcdSuggestions(data.predictions || []);
        setCcdDropdownOpen((data.predictions || []).length > 0);
      } catch (_) {
        setCcdSuggestions([]);
      }
    }, 350);
  };

  // Pick a suggestion: fetch its details then fill the form
  const handleCcdSuggestionClick = async (prediction) => {
    setCcdDropdownOpen(false);
    setCcdSuggestions([]);
    // Show the description immediately so the input isn't blank while we wait
    setDeliveryAddressForm((prev) => ({ ...prev, house: prediction.description }));
    try {
      const res = await fetch(
        `/api/places-details?place_id=${encodeURIComponent(prediction.place_id)}`
      );
      const data = await res.json();
      if (data.result) handlePlaceParsed(data.result);
    } catch (_) {}
  };

  const isAddressFormValid = (f = deliveryAddressForm) =>
    !!(
      f.house &&
      f.apartment &&
      f.landmark &&
      f.city &&
      f.state &&
      /^\d{6}$/.test(f.pincode) &&
      /^\d{10}$/.test(f.phone) &&
      (f.addressType !== "OTHER" || f.otherName?.trim())
    );

  const validateAddressForm = () => {
    const f = deliveryAddressForm;
    const errs = {};
    if (f.addressType === "OTHER" && (!f.otherName || !f.otherName.trim())) {
      errs.otherName = "Required";
    }
    if (!f.house) errs.house = "Required";
    if (!f.apartment) errs.apartment = "Required";
    if (!f.landmark) errs.landmark = "Required";
    if (!f.city) errs.city = "Required";
    if (!f.state) errs.state = "Required";
    if (!f.pincode || !/^\d{6}$/.test(f.pincode)) errs.pincode = "6 digits required";
    if (!f.phone || !/^\d{10}$/.test(f.phone)) errs.phone = "10 digits required";
    setAddressFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const [gstPartnerModalOpen, setGstPartnerModalOpen] = useState(false);
  const [gstLoading, setGstLoading] = useState(false);

  const user_name = localStorage.getItem("user_name");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");

  /* ── GST / SALES_ORDER flow ──────────────────────────────────────────── */

  const _buildAddrCcd = (addr) => ({
    addressId: addr?.id || addr?.addressId || 0,
    country: addr?.country || "India",
    state: addr?.state || "",
    city: addr?.city || "",
    pinCode: addr?.pincode || addr?.pinCode || "",
    phoneNo: addr?.mobileNumber || addr?.phoneNo || "",
    addressLine1: addr?.addressLine1 || "",
    addressLine2: addr?.addressLine2 || "",
    type: "RETAIL",
    updatedBy: retailUserDetails?.uidx || "",
    updatedOn: "",
  });

  const _doCreateSalesOrderCartCcd = (gstContext) => {
    setGstLoading(true);
    const partner = gstContext.partnerDetails || gstContext.partner || {};
    const billingAddr =
      gstContext.partnerDetails?.addresses?.find((a) => a.defaultBilling) ||
      gstContext.partnerDetails?.addresses?.[0] ||
      {};
    const shippingAddr =
      gstContext.partnerDetails?.addresses?.find((a) => a.defaultShipping) || billingAddr;

    const hasAddress =
      gstContext.type === "ORGANIZATION" && gstContext.partnerDetails?.addresses?.length > 0;

    const payload = {
      userName: partner?.displayName || gstContext.partner?.displayName || "B2B Customer",
      userId: gstContext.partner?.retailId || "",
      mobileNo: partner?.contacts?.[0]?.phoneNo || gstContext.partner?.phoneNumber || "",
      enableWhatsapp: false,
      createdBy: retailUserDetails?.firstName || "",
      locationId: locId,
      orderType: "SALES_ORDER",
      sourceId: orgId,
      loggedInUser: retailUserDetails?.uidx || "",
      sourceLocationId: locId,
      sourceType: "RETAIL",
      sourceApp: "PALLET_RETAIL",
      destinationId: orgId,
      destinationLocationId: locId,
      destinationType: "RETAIL",
      subOrderType: "B2B_POS",
      licenseId: licenseId || null,
      terminalName: licenseName || null,
      comments: gstContext.gstNumber ? `GST: ${gstContext.gstNumber}` : "",
      ...(hasAddress
        ? {
            address: {
              billingAddress: { ..._buildAddrCcd(billingAddr), gstIn: gstContext.gstNumber || "" },
              shippingAddress: {
                ..._buildAddrCcd(shippingAddr),
                gstIn: gstContext.gstNumber || "",
              },
            },
          }
        : {}),
    };

    createSalesOrderCart(payload)
      .then((res) => {
        if (res?.data?.status === "error" || res?.data?.data?.es > 0) {
          showSnackbar(res?.data?.message || "Failed to create B2B order", "error");
          return;
        }
        const data = res?.data?.data?.data;
        if (data) {
          setCartId(data.cartId);
          setCartItems(data.cartProducts || []);
          setCartTotalQty(data.billing?.quantity);
          setCgst(data.billing?.cgst);
          setSgst(data.billing?.sgst);
          setCess(data.billing?.totalCessAmount);
          setSubTotal(data.billing?.totalCartValue);
          setTotal(data.billing?.totalCartValue);
          setTotalValue(data.billing?.totalValue);
          localStorage.setItem("CartId", data.cartId);
        }
        localStorage.setItem("cartOrderType", "SALES_ORDER");
        const partnerName =
          partner?.displayName || gstContext.partner?.displayName || "B2B Customer";
        localStorage.setItem("b2bPartnerName", partnerName);
        localStorage.setItem(
          "customer_details",
          JSON.stringify({
            name: partnerName,
            mobileNumber: partner?.contacts?.[0]?.phoneNo || gstContext.partner?.phoneNumber || "",
            uidx: null,
            whatsapp: false,
          })
        );
        setName(partnerName);
        setGstPartnerModalOpen(false);
        setOpenCartCustomerDetail(false);
        showSnackbar("B2B Sales Order created", "success");
      })
      .catch((err) =>
        showSnackbar(err?.message || "Failed to create B2B order. Please try again.", "error")
      )
      .finally(() => setGstLoading(false));
  };

  const handleGstConfirmCcd = (gstContext) => {
    const itemCount = cartItems?.length || 0;
    if (itemCount > 0) {
      Swal.fire({
        title: "Start a fresh B2B order?",
        html: `Your current cart has <strong>${itemCount} item${
          itemCount === 1 ? "" : "s"
        }</strong>. Creating a B2B/GST Sales Order will start a <strong>new empty cart</strong>. The existing items will be discarded.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, create B2B order",
        cancelButtonText: "Keep current cart",
        customClass: {
          confirmButton: "button button-success",
          cancelButton: "button button-error",
          container: "close-session-swal-container",
        },
        buttonsStyling: false,
        backdrop: "rgba(0,0,0,0.4)",
      }).then((result) => {
        if (result.isConfirmed) {
          _doCreateSalesOrderCartCcd(gstContext);
        } else {
          setGstPartnerModalOpen(false);
        }
      });
    } else {
      _doCreateSalesOrderCartCcd(gstContext);
    }
  };

  const isValidMobile =
    selectedCountry?.value === "+91"
      ? customerMobileNumber?.length === 10
      : customerMobileNumber?.length >= 4;

  const isAddressEnabled = isValidMobile;
  const hasSavedHome = savedAddresses?.some((addr) => addr?.addressType === "HOME");
  const hasSavedWork = savedAddresses?.some((addr) => addr?.addressType === "WORK");

  const isAddressFormActive =
    saleMode === "DELIVERY" && (savedAddresses?.length === 0 || showAddressForm);

  const isConfirmButtonVisuallyDisabled =
    saleMode === "DELIVERY" &&
    (isAddressFormActive ||
      (savedAddresses && savedAddresses?.length > 0 && !selectedDeliveryAddress));

  const handleSelectSavedAddress = (addr) => {
    setSelectedDeliveryAddress(addr);
    setShowAddressForm(false);
  };

  const handleEditAddressClick = (e, addr) => {
    e.stopPropagation();
    setEditingAddressId(addr.addressId);
    setShowAddressForm(true);
    setSelectedDeliveryAddress(null);

    const type = ["HOME", "WORK", "OTHER"].includes(addr.addressType) ? addr.addressType : "OTHER";

    setDeliveryAddressForm({
      addressType: type,
      otherName: type === "OTHER" ? addr?.otherName || addr?.addressType || "" : "",
      house: addr?.addressLine1 || "",
      apartment: addr?.addressLine2 || "",
      landmark: addr?.landmark || "",
      city: addr?.city || "",
      state: addr?.state || "",
      pincode: addr?.pincode || "",
      phone: addr?.phoneNumber || "",
      latitude: null,
      longitude: null,
    });
  };

  const handleAddAddressClick = () => {
    setEditingAddressId(null);
    setShowAddressForm(true);
    setSelectedDeliveryAddress(null);
    const hasHome = savedAddresses?.some((addr) => addr?.addressType === "HOME");
    const hasWork = savedAddresses?.some((addr) => addr?.addressType === "WORK");
    let initialType = "HOME";
    if (hasHome && hasWork) {
      initialType = "OTHER";
    } else if (hasHome) {
      initialType = "WORK";
    }
    setDeliveryAddressForm({
      addressType: initialType,
      otherName: "",
      house: "",
      apartment: "",
      landmark: "",
      city: "",
      state: "",
      pincode: "",
      phone: "",
      latitude: null,
      longitude: null,
    });
  };

  const saleModeLabel =
    saleMode === "DINE_IN"
      ? "Dine In"
      : saleMode === "TAKE_AWAY"
      ? "Take Away"
      : saleMode === "DELIVERY"
      ? "Delivery"
      : saleMode || "—";

  return (
    <Modal open={open} disableEscapeKeyDown>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100%",
          width: isMobile ? "100%" : "min(980px, 100vw)",
          bgcolor: "#fff",
          borderRadius: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: "0 40px 120px rgba(15,23,42,0.28)",
          borderLeft: "1px solid rgba(255, 255, 255, 0.7)",
          animation: "ccdSlideIn 0.25s ease",
          transition: "width 0.25s ease",
        }}
      >
        {/* ── HEADER ── */}
        <div className="ccd-header-ref">
          <h2 className="ccd-title-ref" data-testid="text-customer-popup-title">
            Add customer to this order
          </h2>
          {!hideCloseBtn && (
            <button
              className="ccd-close-btn-ref"
              onClick={() => setOpenCartCustomerDetail(false)}
              data-testid="button-customer-modal-close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-x h-4 w-4 text-slate-500"
                style={{ width: "16px", height: "16px", color: "#64748b" }}
                aria-hidden="true"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          )}
        </div>

        {/* ── Pallet delivery mascot — full-width transit lane (empty state only) ── */}
        {!isValidMobile && <CcdDeliveryMascot />}

        {/* ── SPLIT GRID LAYOUT ── */}
        <div className="ccd-split-grid">
          {/* ── FORM SIDE (Left Column) ── */}
          <div className="ccd-form-side-ref">
            <div className="ccd-form-content-ref">
              <div className="ccd-form-scrollable-ref">
                {/* ORDER OPTION cards — QSR only; FINE_DINE has a fixed DINE_IN mode */}
                {branchSubType === "QSR" && (
                  <div
                    className={`ccd-order-option-section-ref${
                      !isValidMobile ? " ccd-order-compact" : ""
                    }`}
                  >
                    <p className="ccd-section-label-ref">Order option</p>
                    <div className="ccd-option-grid-ref">
                      <button
                        type="button"
                        className={`ccd-option-card-ref${saleMode === "DINE_IN" ? " active" : ""}`}
                        onClick={() => handleOptionChange({ target: { value: "DINE_IN" } })}
                        data-testid="button-customer-order-option-in-store"
                      >
                        <div className="ccd-option-card-inner-ref">
                          <div className="ccd-option-icon-container-ref">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-store h-3.5 w-3.5"
                              aria-hidden="true"
                            >
                              <path d="M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5"></path>
                              <path d="M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244"></path>
                              <path d="M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05"></path>
                            </svg>
                          </div>
                          <p className="ccd-option-text-ref">
                            {retailType === "RESTAURANT" ? "Dine In" : "In-store"}
                          </p>
                        </div>
                      </button>

                      <button
                        type="button"
                        className={`ccd-option-card-ref${
                          saleMode === "TAKE_AWAY" ? " active" : ""
                        }`}
                        onClick={() => handleOptionChange({ target: { value: "TAKE_AWAY" } })}
                        data-testid="button-customer-order-option-curbside"
                      >
                        <div className="ccd-option-card-inner-ref">
                          <div className="ccd-option-icon-container-ref">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-bike h-3.5 w-3.5"
                              aria-hidden="true"
                            >
                              <circle cx="18.5" cy="17.5" r="3.5"></circle>
                              <circle cx="5.5" cy="17.5" r="3.5"></circle>
                              <circle cx="15" cy="5" r="1"></circle>
                              <path d="M12 17.5V14l-3-3 4-3 2 3h2"></path>
                            </svg>
                          </div>
                          <p className="ccd-option-text-ref">
                            {retailType === "RESTAURANT" ? "Take Away" : "Curbside pick up"}
                          </p>
                        </div>
                      </button>

                      <button
                        type="button"
                        className={`ccd-option-card-ref${saleMode === "DELIVERY" ? " active" : ""}`}
                        onClick={() => handleOptionChange({ target: { value: "DELIVERY" } })}
                        data-testid="button-customer-order-option-delivery"
                      >
                        <div className="ccd-option-card-inner-ref">
                          <div className="ccd-option-icon-container-ref">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-map-pin h-3.5 w-3.5"
                              aria-hidden="true"
                            >
                              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                              <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                          </div>
                          <p className="ccd-option-text-ref">Delivery</p>
                        </div>
                      </button>
                    </div>
                  </div>
                )}

                {/* Mobile + Name — side by side */}
                <div
                  className={`ccd-inputs-grid-ref${!isValidMobile ? " ccd-inputs-compact" : ""}`}
                >
                  <div>
                    <label className="ccd-input-label-ref">Mobile number</label>
                    <div className="ccd-mobile-input-row-ref">
                      <FormControl variant="standard" sx={{ width: "100%" }}>
                        <NewCountryCodeInput
                          countryOptions={countryOptions}
                          setCustomerMobileNumber={setCustomerMobileNumber}
                          customerMobileNumber={customerMobileNumber}
                          handleKeyPress={handleKeyPress}
                          selectedCountry={selectedCountry}
                          handleCountryChange={handleCountryChange}
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div>
                    <label className="ccd-input-label-ref">Customer name</label>
                    <FormControl variant="standard" sx={{ width: "100%" }}>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          height: "48px",
                        }}
                      >
                        <BootstrapInput
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-input": {
                              backgroundColor: "#ffffff",
                              border: "1px solid #e2e8f0",
                              borderRadius: "20px",
                              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05) !important",
                              fontSize: "0.875rem !important",
                              fontWeight: "500 !important",
                              color: "#333333 !important",
                              padding: customerSearchLoader
                                ? "12px 40px 12px 16px !important"
                                : "12px 16px !important",
                              height: "48px !important",
                              boxSizing: "border-box !important",
                              "&::placeholder": {
                                color: "#65758B !important",
                                opacity: 1,
                                fontSize: "0.875rem !important",
                                fontWeight: "400 !important",
                              },
                              "&.Mui-disabled": {
                                backgroundColor: "#f1f5f9 !important",
                                color: "#94a3b8 !important",
                                WebkitTextFillColor: "#94a3b8 !important",
                                cursor: "not-allowed !important",
                              },
                            },
                          }}
                          className="customer-name-new"
                          placeholder="Enter customer name"
                          id="bootstrap-input"
                          value={customerName}
                          onChange={(e) => setCustomerName(e.target.value)}
                          onKeyDown={handleKeyPress}
                          disabled={!customerMobileNumber}
                          data-testid="input-customer-name"
                        />
                        {customerSearchLoader && (
                          <CircularProgress
                            size={18}
                            sx={{
                              position: "absolute",
                              right: "16px",
                              top: "30%",
                              transform: "translateY(-50%)",
                              color: "#2a71ff",
                              zIndex: 10,
                            }}
                          />
                        )}
                      </div>
                    </FormControl>
                  </div>
                </div>

                {/* WhatsApp notification toggle */}
                <label htmlFor="ccd-whatsapp-chk" className="ccd-whatsapp-row">
                  <img src={WhatsAppLogo} alt="" className="ccd-whatsapp-icon" aria-hidden="true" />
                  <span className="ccd-whatsapp-label">Get notification on WhatsApp</span>
                  <div className={`ccd-wa-toggle${whatsAppCheck ? " ccd-wa-toggle--on" : ""}`}>
                    <div className="ccd-wa-thumb" />
                  </div>
                  <input
                    type="checkbox"
                    id="ccd-whatsapp-chk"
                    checked={whatsAppCheck}
                    onChange={(e) => setWhatsAppCheck(e.target.checked)}
                    style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
                  />
                </label>
                <p className="ccd-whatsapp-note">
                  Sending WhatsApp notifications requires a WhatsApp API integration. Connect your
                  own number, or subscribe to a <strong>Pallet Notifications plan</strong> to send
                  messages via a Pallet-managed number.
                </p>

                {/* ── Delivery / Takeaway slot section ── */}
                {(saleMode === "DELIVERY" || saleMode === "TAKE_AWAY") &&
                  customerMobileNumber?.length === 10 && (
                    <div className="ccd-delivery-section">
                      {!showAddressForm && (
                        <>
                          <p className="ccd-delivery-section-label">
                            {saleMode === "TAKE_AWAY" ? "Takeaway Mode" : "DELIVERY MODE"}
                          </p>
                          <p className="ccd-delivery-section-desc">
                            {saleMode === "TAKE_AWAY"
                              ? "Choose when the guest wants to collect the order."
                              : "Choose how this order should be dispatched."}
                          </p>
                          <div className="ccd-delivery-mode-options">
                            <div
                              className={`ccd-delivery-mode-option${
                                pickupMode === "instant" ? " active" : ""
                              }`}
                              onClick={() => setPickupMode("instant")}
                            >
                              <div className="ccd-delivery-mode-option-text">
                                <span className="ccd-delivery-mode-option-title">
                                  {saleMode === "TAKE_AWAY" ? "Instant pickup" : "Instant delivery"}
                                </span>
                                <span className="ccd-delivery-mode-option-desc">
                                  {saleMode === "TAKE_AWAY"
                                    ? "Pickup starts as soon as the order is ready."
                                    : "Dispatch as soon as the kitchen starts."}
                                </span>
                              </div>
                              <div
                                className={`ccd-delivery-radio${
                                  pickupMode === "instant" ? " active" : ""
                                }`}
                              />
                            </div>
                            <div
                              className={`ccd-delivery-mode-option${
                                pickupMode === "slot" ? " active" : ""
                              }`}
                              onClick={() => setPickupMode("slot")}
                            >
                              <div className="ccd-delivery-mode-option-text">
                                <span className="ccd-delivery-mode-option-title">
                                  Choose a slot
                                </span>
                                <span className="ccd-delivery-mode-option-desc">
                                  {saleMode === "TAKE_AWAY"
                                    ? "Reserve a pickup time window."
                                    : "Reserve a specific delivery window."}
                                </span>
                              </div>
                              <div
                                className={`ccd-delivery-radio${
                                  pickupMode === "slot" ? " active" : ""
                                }`}
                              />
                            </div>
                          </div>

                          {pickupMode === "slot" && (
                            <div className="ccd-delivery-slots-container">
                              <div className="ccd-delivery-slots-header">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="ccd-delivery-slots-clock-icon"
                                  aria-hidden="true"
                                >
                                  <path d="M16 14v2.2l1.6 1" />
                                  <path d="M16 2v4" />
                                  <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" />
                                  <path d="M3 10h5" />
                                  <path d="M8 2v4" />
                                  <circle cx="16" cy="16" r="6" />
                                </svg>
                                {saleMode === "TAKE_AWAY"
                                  ? "Select pickup date & time"
                                  : "Select delivery date & time"}
                              </div>

                              {/* Date Chips */}
                              <div className="ccd-delivery-date-chips-container">
                                {dateChips?.length > 0 ? (
                                  dateChips?.map((item) => (
                                    <button
                                      key={item?.date}
                                      type="button"
                                      className={`ccd-delivery-date-chip-btn${
                                        date.toDateString() === item?.actualDate?.toDateString()
                                          ? " ccd-delivery-date-chip-btn--selected"
                                          : ""
                                      }`}
                                      onClick={() => handleDate(item?.actualDate)}
                                    >
                                      {item?.date}
                                    </button>
                                  ))
                                ) : (
                                  <p className="ccd-delivery-slots-empty">No Dates Found</p>
                                )}
                              </div>

                              {/* Slots List / Loading */}
                              {slotsLoading ? (
                                <div className="ccd-delivery-slots-loader">
                                  <span className="ccd-delivery-slots-spinner" />
                                </div>
                              ) : (
                                <div className="ccd-delivery-slots-grid">
                                  {filteredSlots?.length > 0 ? (
                                    filteredSlots?.map((slot) => {
                                      const isSelected = selectedSlotId === slot?.slotId;
                                      return (
                                        <button
                                          key={slot?.slotId}
                                          type="button"
                                          className={
                                            isSelected
                                              ? "ccd-delivery-slot-btn--selected"
                                              : "ccd-delivery-slot-btn--unselected"
                                          }
                                          onClick={() => setSelectedSlotId(slot?.slotId)}
                                        >
                                          {slot?.instant
                                            ? "Now"
                                            : `${slot?.startTime} - ${slot?.endTime}`}
                                        </button>
                                      );
                                    })
                                  ) : (
                                    <p className="ccd-delivery-slots-empty">No Slots Found</p>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )}

                      {/* ── Delivery address section ── */}
                      {saleMode === "DELIVERY" && customerMobileNumber?.length === 10 && (
                        <>
                          <div className="ccd-delivery-address-header">
                            <div className="ccd-delivery-address-header-inner">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="ccd-delivery-address-header-icon"
                                aria-hidden="true"
                              >
                                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                                <circle cx="12" cy="10" r="3" />
                              </svg>
                              Delivery address
                            </div>
                          </div>
                          <div className="ccd-section ccd-address-section">
                            {/* Saved addresses */}
                            {addressFetchLoader ? (
                              <div className="ccd-addr-loader">Fetching saved addresses…</div>
                            ) : (
                              savedAddresses?.length > 0 && (
                                <div className="ccd-saved-addresses-section">
                                  <div className="ccd-saved-addresses-header">
                                    <label className="ccd-saved-addresses-title">
                                      SAVED ADDRESSES
                                    </label>
                                    {!showAddressForm && (
                                      <button
                                        type="button"
                                        className="ccd-add-address-link"
                                        onClick={handleAddAddressClick}
                                        disabled={!isAddressEnabled}
                                        data-testid="button-customer-add-address"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="lucide lucide-plus h-3.5 w-3.5"
                                          aria-hidden="true"
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            marginRight: "4px",
                                          }}
                                        >
                                          <path d="M5 12h14" />
                                          <path d="M12 5v14" />
                                        </svg>
                                        Add Address
                                      </button>
                                    )}
                                  </div>
                                  <div className="ccd-saved-addresses-grid">
                                    {savedAddresses
                                      ?.filter(
                                        (addr) =>
                                          !editingAddressId || addr?.addressId === editingAddressId
                                      )
                                      ?.map((addr) => {
                                        const isSelected =
                                          selectedDeliveryAddress?.addressId === addr?.addressId;
                                        const addrLabel =
                                          addr?.addressType === "OTHER"
                                            ? addr?.otherName || "Other"
                                            : addr?.addressType === "HOME"
                                            ? "Home"
                                            : addr?.addressType === "WORK"
                                            ? "Work"
                                            : "Address";
                                        return (
                                          <div
                                            key={addr?.addressId}
                                            className={`ccd-saved-address-card${
                                              isSelected ? " active" : ""
                                            }`}
                                            onClick={() =>
                                              isAddressEnabled && handleSelectSavedAddress(addr)
                                            }
                                          >
                                            <div className="ccd-saved-address-card-header">
                                              <span className="ccd-saved-address-type-label">
                                                {addrLabel}
                                              </span>
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  isAddressEnabled &&
                                                    handleEditAddressClick(e, addr);
                                                }}
                                                className="ccd-edit-address-pen-btn"
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  className="lucide lucide-pen h-3.5 w-3.5"
                                                  aria-hidden="true"
                                                  style={{ width: "14px", height: "14px" }}
                                                >
                                                  <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
                                                </svg>
                                              </button>
                                            </div>
                                            <p className="ccd-saved-address-description">
                                              {addr?.addressLine1}
                                              {addr?.addressLine2 ? `, ${addr?.addressLine2}` : ""}
                                              {addr?.landmark ? `, Near ${addr?.landmark}` : ""}
                                              {addr?.city ? `, ${addr?.city}` : ""}
                                              {addr?.pincode ? ` - ${addr?.pincode}` : ""}
                                            </p>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              )
                            )}

                            {showAddressForm && (
                              <>
                                <div className="ccd-addr-form">
                                  {/* Address type */}
                                  <div className="ccd-addr-type-options">
                                    {["HOME", "WORK", "OTHER"].map((t) => {
                                      const isDisabled =
                                        (t === "HOME" && hasSavedHome) ||
                                        (t === "WORK" && hasSavedWork);
                                      return (
                                        <div
                                          key={t}
                                          className={`ccd-addr-type-option${
                                            deliveryAddressForm?.addressType === t ? " active" : ""
                                          }${isDisabled ? " disabled" : ""}`}
                                          onClick={() => {
                                            if (!isDisabled && isAddressEnabled) {
                                              setDeliveryAddressForm((p) => ({
                                                ...p,
                                                addressType: t,
                                              }));
                                              setSelectedDeliveryAddress(null);
                                            }
                                          }}
                                        >
                                          <span className="ccd-addr-type-label-text">
                                            {t === "HOME"
                                              ? "Home"
                                              : t === "WORK"
                                              ? "Work"
                                              : "Others"}
                                          </span>
                                          <div
                                            className={`ccd-addr-radio${
                                              deliveryAddressForm?.addressType === t
                                                ? " active"
                                                : ""
                                            }${isDisabled ? " disabled" : ""}`}
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>

                                  {deliveryAddressForm?.addressType === "OTHER" && (
                                    <div className="ccd-addr-input-group ccd-addr-input-group--full">
                                      <label className="ccd-addr-input-label">Address Name</label>
                                      <div className="ccd-addr-input-wrap">
                                        <input
                                          className="ccd-addr-input ccd-addr-input--no-icon"
                                          name="otherName"
                                          placeholder="e.g. Friend's House, Parent's Home"
                                          value={deliveryAddressForm?.otherName}
                                          onChange={handleAddressFormChange}
                                          disabled={!isAddressEnabled}
                                        />
                                      </div>
                                      {addressFormErrors?.otherName && (
                                        <span className="ccd-addr-error">
                                          {addressFormErrors?.otherName}
                                        </span>
                                      )}
                                    </div>
                                  )}

                                  <div
                                    className="ccd-addr-input-group ccd-addr-input-group--full"
                                    style={{ position: "relative" }}
                                  >
                                    <label className="ccd-addr-input-label">
                                      House / flat / floor no.
                                      <span
                                        style={{
                                          fontWeight: 400,
                                          fontSize: "0.68rem",
                                          color: "#94a3b8",
                                          marginLeft: 4,
                                        }}
                                      >
                                        — type to search address
                                      </span>
                                    </label>
                                    <div className="ccd-addr-input-wrap">
                                      <AddressPinIcon />
                                      <input
                                        ref={ccdHouseInputRef}
                                        className="ccd-addr-input"
                                        name="house"
                                        placeholder="Enter house/flat no. or full address"
                                        value={deliveryAddressForm?.house || ""}
                                        onChange={(e) => {
                                          handleAddressFormChange(e);
                                          fetchCcdSuggestions(e.target.value);
                                        }}
                                        onBlur={() =>
                                          setTimeout(() => {
                                            setCcdDropdownOpen(false);
                                          }, 200)
                                        }
                                        onFocus={() =>
                                          ccdSuggestions.length > 0 && setCcdDropdownOpen(true)
                                        }
                                        disabled={!isAddressEnabled}
                                        autoComplete="off"
                                      />
                                    </div>
                                    {ccdDropdownOpen && ccdSuggestions.length > 0 && (
                                      <ul className="ccd-places-dropdown">
                                        {ccdSuggestions.map((p) => (
                                          <li
                                            key={p.place_id}
                                            className="ccd-places-dropdown-item"
                                            onMouseDown={(e) => {
                                              e.preventDefault();
                                              handleCcdSuggestionClick(p);
                                            }}
                                          >
                                            <span className="ccd-places-main">
                                              {p.structured_formatting?.main_text || p.description}
                                            </span>
                                            <span className="ccd-places-secondary">
                                              {p.structured_formatting?.secondary_text || ""}
                                            </span>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                    {deliveryAddressForm?.latitude &&
                                      deliveryAddressForm?.longitude && (
                                        <span
                                          style={{
                                            fontSize: "0.7rem",
                                            color: "#16a34a",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 3,
                                            marginTop: 2,
                                          }}
                                        >
                                          📍 Location saved
                                        </span>
                                      )}
                                    {addressFormErrors?.house && (
                                      <span className="ccd-addr-error">
                                        {addressFormErrors?.house}
                                      </span>
                                    )}
                                  </div>

                                  <div className="ccd-addr-input-group ccd-addr-input-group--full">
                                    <label className="ccd-addr-input-label">
                                      Apartment / road / area
                                    </label>
                                    <div className="ccd-addr-input-wrap">
                                      <input
                                        className="ccd-addr-input ccd-addr-input--no-icon"
                                        name="apartment"
                                        placeholder="Enter area"
                                        value={deliveryAddressForm?.apartment}
                                        onChange={handleAddressFormChange}
                                        disabled={!isAddressEnabled}
                                      />
                                    </div>
                                    {addressFormErrors?.apartment && (
                                      <span className="ccd-addr-error">
                                        {addressFormErrors?.apartment}
                                      </span>
                                    )}
                                  </div>

                                  <div className="ccd-addr-input-group ccd-addr-input-group--full">
                                    <label className="ccd-addr-input-label">Nearby landmark</label>
                                    <div className="ccd-addr-input-wrap">
                                      <input
                                        className="ccd-addr-input ccd-addr-input--no-icon"
                                        name="landmark"
                                        placeholder="Enter landmark"
                                        value={deliveryAddressForm?.landmark}
                                        onChange={handleAddressFormChange}
                                        disabled={!isAddressEnabled}
                                      />
                                    </div>
                                    {addressFormErrors?.landmark && (
                                      <span className="ccd-addr-error">
                                        {addressFormErrors?.landmark}
                                      </span>
                                    )}
                                  </div>

                                  <div className="ccd-addr-inputs-row">
                                    {/* ── State — select dropdown, first ── */}
                                    <div className="ccd-addr-input-group">
                                      <label className="ccd-addr-input-label">State</label>
                                      <CustomStateSelect
                                        value={deliveryAddressForm?.state}
                                        onChange={handleAddressFormChange}
                                        options={INDIA_STATES}
                                        disabled={!isAddressEnabled}
                                      />
                                      {addressFormErrors?.state && (
                                        <span className="ccd-addr-error">
                                          {addressFormErrors?.state}
                                        </span>
                                      )}
                                    </div>
                                    {/* ── City — free-text + datalist, second ── */}
                                    <div className="ccd-addr-input-group">
                                      <label className="ccd-addr-input-label">City</label>
                                      <div className="ccd-addr-input-wrap">
                                        <input
                                          className="ccd-addr-input ccd-addr-input--no-icon"
                                          name="city"
                                          list="ccd-city-datalist"
                                          placeholder={
                                            deliveryAddressForm?.state
                                              ? "Type or select city"
                                              : "Select state first"
                                          }
                                          value={deliveryAddressForm?.city}
                                          onChange={handleAddressFormChange}
                                          disabled={!isAddressEnabled}
                                          autoComplete="off"
                                        />
                                      </div>
                                      {getCitiesForState(deliveryAddressForm?.state).length > 0 && (
                                        <datalist id="ccd-city-datalist">
                                          {getCitiesForState(deliveryAddressForm?.state).map(
                                            (c) => (
                                              <option key={c} value={c} />
                                            )
                                          )}
                                        </datalist>
                                      )}
                                      {addressFormErrors?.city && (
                                        <span className="ccd-addr-error">
                                          {addressFormErrors?.city}
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <div className="ccd-addr-inputs-row">
                                    <div className="ccd-addr-input-group">
                                      <label className="ccd-addr-input-label">Pincode</label>
                                      <div className="ccd-addr-input-wrap">
                                        <input
                                          className="ccd-addr-input ccd-addr-input--no-icon"
                                          name="pincode"
                                          placeholder="Pincode"
                                          type="number"
                                          value={deliveryAddressForm?.pincode}
                                          onChange={handleAddressFormChange}
                                          disabled={!isAddressEnabled}
                                        />
                                      </div>
                                      {addressFormErrors?.pincode && (
                                        <span className="ccd-addr-error">
                                          {addressFormErrors?.pincode}
                                        </span>
                                      )}
                                    </div>

                                    <div className="ccd-addr-input-group">
                                      <label className="ccd-addr-input-label">
                                        Receiver&apos;s phone number
                                      </label>
                                      <div className="ccd-addr-input-wrap">
                                        <PhoneIcon />
                                        <input
                                          className="ccd-addr-input"
                                          name="phone"
                                          placeholder="10-digit number"
                                          type="number"
                                          value={deliveryAddressForm?.phone}
                                          onChange={handleAddressFormChange}
                                          disabled={!isAddressEnabled}
                                        />
                                      </div>
                                      {addressFormErrors?.phone && (
                                        <span className="ccd-addr-error">
                                          {addressFormErrors?.phone}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {editingAddressId ? (
                                  <div className="ccd-edit-address-actions">
                                    <button
                                      type="button"
                                      className="ccd-edit-address-btn-cancel"
                                      onClick={handleCancelEdit}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="ccd-edit-address-btn-update"
                                      onClick={handleUpdateAddressClick}
                                      disabled={addModelLoader || !isAddressFormValid()}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      {addModelLoader ? (
                                        <>
                                          <CircularProgress size={16} color="inherit" />
                                          Updating…
                                        </>
                                      ) : (
                                        "Update"
                                      )}
                                    </button>
                                  </div>
                                ) : (
                                  <div className="ccd-edit-address-actions">
                                    {savedAddresses?.length > 0 && (
                                      <button
                                        type="button"
                                        className="ccd-edit-address-btn-cancel"
                                        onClick={handleCancelEdit}
                                      >
                                        Cancel
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      className="ccd-edit-address-btn-update"
                                      onClick={handleSaveAddress}
                                      disabled={addModelLoader || !isAddressFormValid()}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        gridColumn:
                                          savedAddresses?.length > 0 ? "span 1" : "span 2",
                                      }}
                                    >
                                      {addModelLoader ? (
                                        <>
                                          <CircularProgress size={16} color="inherit" />
                                          Saving…
                                        </>
                                      ) : (
                                        "Save Address"
                                      )}
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </>
                      )}

                      {/* {!editingAddressId &&
                        saleMode === "TAKE_AWAY" &&
                        customerMobileNumber?.length === 10 && (
                          <div className="ccd-charges-section">
                            <div className="ccd-charges-row">
                              <div className="ccd-charge-group">
                                <label className="ccd-charge-label">Packing Charges</label>
                                <div className="ccd-charge-input-wrap">
                                  <span className="ccd-charge-currency-prefix"></span>
                                  <input
                                    id="packingCharges"
                                    type="text"
                                    inputMode="decimal"
                                    placeholder="0.00"
                                    className="ccd-charge-input"
                                    value={packingCharges}
                                    onChange={(e) => handleChargesChange(e, "packing")}
                                    data-testid="input-delivery-packing-charges"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )} */}

                      {/* {!editingAddressId &&
                        saleMode === "DELIVERY" &&
                        customerMobileNumber?.length === 10 &&
                        !isAddressFormActive && (
                          <div className="ccd-charges-section">
                            <div className="ccd-charges-row">
                              <div className="ccd-charge-group">
                                <label className="ccd-charge-label">Packing Charges</label>
                                <div className="ccd-charge-input-wrap">
                                  <span className="ccd-charge-currency-prefix"></span>
                                  <input
                                    id="packingCharges"
                                    type="text"
                                    inputMode="decimal"
                                    placeholder="0.00"
                                    className="ccd-charge-input"
                                    value={packingCharges}
                                    onChange={(e) => handleChargesChange(e, "packing")}
                                    data-testid="input-delivery-packing-charges"
                                  />
                                </div>
                              </div>
                              <div className="ccd-charge-group">
                                <label className="ccd-charge-label">Delivery Charges</label>
                                <div className="ccd-charge-input-wrap">
                                  <span className="ccd-charge-currency-prefix"></span>
                                  <input
                                    id="deliveryCharge"
                                    type="text"
                                    inputMode="decimal"
                                    placeholder="0.00"
                                    className="ccd-charge-input"
                                    value={deliveryCharges}
                                    onChange={(e) => handleChargesChange(e, "delivery")}
                                    data-testid="input-delivery-charges"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )} */}
                    </div>
                  )}
              </div>
            </div>
          </div>

          {/* ── INSIGHTS SIDE (Right Column) ── */}
          <div className="ccd-insights-side-ref">
            <div className="ccd-insights-content-ref">
              <p className="ccd-insights-title-ref">Customer insights</p>
              {!isValidMobile ? (
                /* Empty state */
                <div className="ccd-insights-empty-card-ref">
                  <div className="ccd-insights-empty-icon-ref">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-user h-5 w-5"
                      aria-hidden="true"
                    >
                      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <p className="ccd-insights-empty-title-ref">Waiting for customer details</p>
                  <p
                    className="ccd-insights-empty-sub-ref"
                    data-testid="text-customer-preview-empty-state"
                  >
                    Add a mobile number and name to continue with the selected order flow.
                  </p>
                </div>
              ) : (
                <>
                  <div className="ccd-insights-card-ref">
                    <div className="ccd-insights-card-header-ref">
                      <div>
                        <p
                          className="ccd-insights-card-name-ref"
                          data-testid="text-customer-preview-name"
                        >
                          {customerName || "—"}
                        </p>
                        <p
                          className="ccd-insights-card-mobile-ref"
                          data-testid="text-customer-preview-mobile"
                        >
                          {selectedCountry?.value} {customerMobileNumber}
                        </p>
                      </div>
                      <div
                        className="ccd-insights-card-badge-ref"
                        data-testid="status-customer-preview-member-since"
                      >
                        {(() => {
                          const created =
                            foundCustomer?.createdAt ||
                            foundCustomer?.updatedAt ||
                            foundCustomer?.created;
                          return created ? moment(created).format("MMM YYYY") : "...";
                        })()}
                      </div>
                    </div>
                    <div className="ccd-insights-card-option-ref">
                      <p className="ccd-insights-card-option-label-ref">Order option</p>
                      <p
                        className="ccd-insights-card-option-val-ref"
                        data-testid="text-customer-preview-order-option"
                      >
                        {saleModeLabel}
                      </p>
                    </div>
                  </div>

                  <div className="ccd-insights-grid-ref">
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Total orders</p>
                      <p
                        className="ccd-insights-tile-val-ref"
                        data-testid="text-customer-preview-total-orders"
                      >
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          formatInsightCount(insights?.totalOrders)
                        )}
                      </p>
                    </div>
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Loyalty points</p>
                      <p
                        className="ccd-insights-tile-val-ref"
                        data-testid="text-customer-preview-loyalty-points"
                      >
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          formatInsightCount(insights?.loyaltyPoints)
                        )}
                      </p>
                    </div>
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Wallet Balance</p>
                      <div className="ccd-insights-tile-val-ref">
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-wallet h-4 w-4 text-emerald-500"
                              aria-hidden="true"
                              style={{ width: "16px", height: "16px", color: "#10B981" }}
                            >
                              <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                              <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                            </svg>
                            <span data-testid="text-customer-preview-wallet-balance">
                              {formatInsightCurrency(insights?.walletBalance)}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="ccd-insights-tile-ref">
                      <p className="ccd-insights-tile-label-ref">Average basket</p>
                      <p
                        className="ccd-insights-tile-val-ref"
                        data-testid="text-customer-preview-average-basket"
                      >
                        {tilesLoading ? (
                          <InsightSpinner />
                        ) : (
                          formatInsightCurrency(insights?.averageBasket)
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="ccd-insights-last-ref">
                    <p className="ccd-insights-last-label-ref">Last ordered</p>
                    <p
                      className="ccd-insights-last-val-ref"
                      data-testid="text-customer-preview-last-ordered"
                    >
                      {tilesLoading ? (
                        <InsightSpinner small />
                      ) : (
                        formatInsightDate(insights?.lastOrderedAt)
                      )}
                    </p>
                  </div>
                </>
              )}

              {/* ── Sponsored-by ad block — always visible ── */}
              <div className="ccd-sponsor-block">
                <span className="ccd-sponsor-label">Sponsored by</span>
                <img src={AachiLogo} alt="Aachi" className="ccd-sponsor-logo" />
              </div>
            </div>
          </div>
        </div>

        {/* GST Partner / B2B modal */}
        <GstPartnerModal
          isOpen={gstPartnerModalOpen}
          onClose={() => setGstPartnerModalOpen(false)}
          onConfirm={handleGstConfirmCcd}
          loading={gstLoading}
        />

        {/* Sticky footer placed at bottom of the modal */}
        {!editingAddressId && (
          <div className="ccd-footer-ref">
            <div className="ccd-footer-inner-ref">
              <button
                className="ccd-btn-skip-ref"
                type="button"
                disabled={skipModelLoader}
                onClick={() => {
                  retailType === "RESTAURANT" &&
                  saleMode === "DINE_IN" &&
                  branchSubType === "FINE_DINE"
                    ? setOpenCartCustomerDetail(false)
                    : handleClose();
                }}
                data-testid="button-customer-skip"
              >
                {skipModelLoader ? "…" : "Skip"}
              </button>
              <button
                className={`ccd-btn-add-ref${
                  isValidMobile && isConfirmButtonVisuallyDisabled ? " visual-disabled" : ""
                }`}
                type="button"
                disabled={
                  addModelLoader ||
                  (selectedCountry?.value === "+91" && customerMobileNumber?.length !== 10) ||
                  isAddressFormActive
                }
                onClick={() => {
                  if (
                    saleMode === "DELIVERY" &&
                    savedAddresses?.length > 0 &&
                    !selectedDeliveryAddress
                  ) {
                    showSnackbar("Please select an address or Add Address", "warning");
                    return;
                  }
                  addCustomerFun();
                }}
                data-testid="button-customer-add"
              >
                {addModelLoader
                  ? isValidMobile
                    ? "Selecting..."
                    : "Adding..."
                  : !isValidMobile
                  ? "Add"
                  : customerFound
                  ? "Select Customer"
                  : "Add Customer"}
              </button>
            </div>
          </div>
        )}
      </Box>
    </Modal>
  );
};
